export const brands = [
  {
    "label": "#LADC",
    "value": "#LADC"
  },
  {
    "label": "&Klevering",
    "value": "&Klevering"
  },
  {
    "label": "'47",
    "value": "'47"
  },
  {
    "label": "10Days",
    "value": "10Days"
  },
  {
    "label": "12 Midnight",
    "value": "12 Midnight"
  },
  {
    "label": "181",
    "value": "181"
  },
  {
    "label": "2XU",
    "value": "2XU"
  },
  {
    "label": "2nd Day",
    "value": "2nd Day"
  },
  {
    "label": "2ndOne",
    "value": "2ndOne"
  },
  {
    "label": "3x1",
    "value": "3x1"
  },
  {
    "label": "4th & Reckless Petite",
    "value": "4th & Reckless Petite"
  },
  {
    "label": "4th & Reckless",
    "value": "4th & Reckless"
  },
  {
    "label": "7 For All Mankind",
    "value": "7 For All Mankind"
  },
  {
    "label": "81hours Studio",
    "value": "81hours Studio"
  },
  {
    "label": "81hours",
    "value": "81hours"
  },
  {
    "label": "8848 Altitude",
    "value": "8848 Altitude"
  },
  {
    "label": "9Fashion",
    "value": "9Fashion"
  },
  {
    "label": "A'JOURNEY - LONDON",
    "value": "A'JOURNEY - LONDON"
  },
  {
    "label": "A",
    "value": "A"
  },
  {
    "label": "A.P.C.",
    "value": "A.P.C."
  },
  {
    "label": "A.S.98",
    "value": "A.S.98"
  },
  {
    "label": "ABOUT YOU",
    "value": "ABOUT YOU"
  },
  {
    "label": "ABRACADA BRA",
    "value": "ABRACADA BRA"
  },
  {
    "label": "ABRO",
    "value": "ABRO"
  },
  {
    "label": "ADIA",
    "value": "ADIA"
  },
  {
    "label": "ADIDAS ORIGINALS",
    "value": "ADIDAS ORIGINALS"
  },
  {
    "label": "ADIDAS PERFORMANCE",
    "value": "ADIDAS PERFORMANCE"
  },
  {
    "label": "AERIN",
    "value": "AERIN"
  },
  {
    "label": "AG Jeans",
    "value": "AG Jeans"
  },
  {
    "label": "AGL",
    "value": "AGL"
  },
  {
    "label": "AGOLDE",
    "value": "AGOLDE"
  },
  {
    "label": "AIRFORCE",
    "value": "AIRFORCE"
  },
  {
    "label": "ALDO Shop",
    "value": "ALDO Shop"
  },
  {
    "label": "ALDO Wide Fit",
    "value": "ALDO Wide Fit"
  },
  {
    "label": "ALDO",
    "value": "ALDO"
  },
  {
    "label": "ALEXACHUNG",
    "value": "ALEXACHUNG"
  },
  {
    "label": "ALOHAS",
    "value": "ALOHAS"
  },
  {
    "label": "AMA Brand",
    "value": "AMA Brand"
  },
  {
    "label": "AMERICAN VINTAGE",
    "value": "AMERICAN VINTAGE"
  },
  {
    "label": "AMOSTYLE",
    "value": "AMOSTYLE"
  },
  {
    "label": "ANGULUS",
    "value": "ANGULUS"
  },
  {
    "label": "ANINE BING",
    "value": "ANINE BING"
  },
  {
    "label": "ANISTON",
    "value": "ANISTON"
  },
  {
    "label": "ANNA + NINA",
    "value": "ANNA + NINA"
  },
  {
    "label": "ANNI LU",
    "value": "ANNI LU"
  },
  {
    "label": "AOS Los Angeles",
    "value": "AOS Los Angeles"
  },
  {
    "label": "ARA",
    "value": "ARA"
  },
  {
    "label": "ARKK Copenhagen",
    "value": "ARKK Copenhagen"
  },
  {
    "label": "ARKK",
    "value": "ARKK"
  },
  {
    "label": "ARMA",
    "value": "ARMA"
  },
  {
    "label": "ARMEDANGELS",
    "value": "ARMEDANGELS"
  },
  {
    "label": "ARTLOVE Paris",
    "value": "ARTLOVE Paris"
  },
  {
    "label": "ASCENO",
    "value": "ASCENO"
  },
  {
    "label": "ASH",
    "value": "ASH"
  },
  {
    "label": "ASICS",
    "value": "ASICS"
  },
  {
    "label": "ATP Atelier",
    "value": "ATP Atelier"
  },
  {
    "label": "Aaiko",
    "value": "Aaiko"
  },
  {
    "label": "Abercrombie & Fitch",
    "value": "Abercrombie & Fitch"
  },
  {
    "label": "Abrand Jeans",
    "value": "Abrand Jeans"
  },
  {
    "label": "Abro",
    "value": "Abro"
  },
  {
    "label": "Acne Studios",
    "value": "Acne Studios"
  },
  {
    "label": "Acqua di Parma",
    "value": "Acqua di Parma"
  },
  {
    "label": "Active by Zizzi",
    "value": "Active by Zizzi"
  },
  {
    "label": "Adele Dezotti",
    "value": "Adele Dezotti"
  },
  {
    "label": "Adidas Timing",
    "value": "Adidas Timing"
  },
  {
    "label": "Adrianna Papell",
    "value": "Adrianna Papell"
  },
  {
    "label": "Aeyde",
    "value": "Aeyde"
  },
  {
    "label": "After Eden",
    "value": "After Eden"
  },
  {
    "label": "Agent Provocateur",
    "value": "Agent Provocateur"
  },
  {
    "label": "Agolde",
    "value": "Agolde"
  },
  {
    "label": "Aiayu",
    "value": "Aiayu"
  },
  {
    "label": "Aigle",
    "value": "Aigle"
  },
  {
    "label": "Aigner",
    "value": "Aigner"
  },
  {
    "label": "Airforce",
    "value": "Airforce"
  },
  {
    "label": "Aku",
    "value": "Aku"
  },
  {
    "label": "Alberto Gozzi",
    "value": "Alberto Gozzi"
  },
  {
    "label": "Alberto Zago",
    "value": "Alberto Zago"
  },
  {
    "label": "Alchemist",
    "value": "Alchemist"
  },
  {
    "label": "Alessandro",
    "value": "Alessandro"
  },
  {
    "label": "Alex Monroe",
    "value": "Alex Monroe"
  },
  {
    "label": "Alexander McQueen",
    "value": "Alexander McQueen"
  },
  {
    "label": "Alexander Wang",
    "value": "Alexander Wang"
  },
  {
    "label": "Alice + Olivia",
    "value": "Alice + Olivia"
  },
  {
    "label": "Alife and Kickin",
    "value": "Alife and Kickin"
  },
  {
    "label": "Alix The Label",
    "value": "Alix The Label"
  },
  {
    "label": "All Yours",
    "value": "All Yours"
  },
  {
    "label": "AllSaints",
    "value": "AllSaints"
  },
  {
    "label": "Alma en Pena",
    "value": "Alma en Pena"
  },
  {
    "label": "Alpaca Loca",
    "value": "Alpaca Loca"
  },
  {
    "label": "Alpe",
    "value": "Alpe"
  },
  {
    "label": "Alpenflüstern",
    "value": "Alpenflüstern"
  },
  {
    "label": "Alpha Industries",
    "value": "Alpha Industries"
  },
  {
    "label": "Alpina",
    "value": "Alpina"
  },
  {
    "label": "Alpinestars",
    "value": "Alpinestars"
  },
  {
    "label": "Amatør",
    "value": "Amatør"
  },
  {
    "label": "Amber Sceats",
    "value": "Amber Sceats"
  },
  {
    "label": "America Today",
    "value": "America Today"
  },
  {
    "label": "American Outfitters",
    "value": "American Outfitters"
  },
  {
    "label": "American Vintage",
    "value": "American Vintage"
  },
  {
    "label": "Amorph Berlin",
    "value": "Amorph Berlin"
  },
  {
    "label": "Amouage",
    "value": "Amouage"
  },
  {
    "label": "Amuse Society",
    "value": "Amuse Society"
  },
  {
    "label": "An Hour And A Shower",
    "value": "An Hour And A Shower"
  },
  {
    "label": "An Ounce",
    "value": "An Ounce"
  },
  {
    "label": "Ana Alcazar",
    "value": "Ana Alcazar"
  },
  {
    "label": "And Less",
    "value": "And Less"
  },
  {
    "label": "Anderson's",
    "value": "Anderson's"
  },
  {
    "label": "Andres Sarda",
    "value": "Andres Sarda"
  },
  {
    "label": "Anecdote",
    "value": "Anecdote"
  },
  {
    "label": "Angulus",
    "value": "Angulus"
  },
  {
    "label": "Anita",
    "value": "Anita"
  },
  {
    "label": "Ann Summers",
    "value": "Ann Summers"
  },
  {
    "label": "Anna + Nina",
    "value": "Anna + Nina"
  },
  {
    "label": "Anna Aura",
    "value": "Anna Aura"
  },
  {
    "label": "Anna Field",
    "value": "Anna Field"
  },
  {
    "label": "Anna Scholz for Sheego",
    "value": "Anna Scholz for Sheego"
  },
  {
    "label": "Anonymous Copenhagen",
    "value": "Anonymous Copenhagen"
  },
  {
    "label": "Another-Label",
    "value": "Another-Label"
  },
  {
    "label": "Anton Heunis",
    "value": "Anton Heunis"
  },
  {
    "label": "Apart",
    "value": "Apart"
  },
  {
    "label": "Apple of Eden",
    "value": "Apple of Eden"
  },
  {
    "label": "Aquanova",
    "value": "Aquanova"
  },
  {
    "label": "Aquatalia",
    "value": "Aquatalia"
  },
  {
    "label": "Arena",
    "value": "Arena"
  },
  {
    "label": "Armani",
    "value": "Armani"
  },
  {
    "label": "Armor lux",
    "value": "Armor lux"
  },
  {
    "label": "Ash",
    "value": "Ash"
  },
  {
    "label": "Ashley Graham x Marina Rinaldi",
    "value": "Ashley Graham x Marina Rinaldi"
  },
  {
    "label": "Asics Tiger",
    "value": "Asics Tiger"
  },
  {
    "label": "Astley Clarke",
    "value": "Astley Clarke"
  },
  {
    "label": "Atelier des Femmes",
    "value": "Atelier des Femmes"
  },
  {
    "label": "Atkinsons",
    "value": "Atkinsons"
  },
  {
    "label": "Aubade",
    "value": "Aubade"
  },
  {
    "label": "Aurélie Bidermann",
    "value": "Aurélie Bidermann"
  },
  {
    "label": "Avril Gau",
    "value": "Avril Gau"
  },
  {
    "label": "Aynur Abbott",
    "value": "Aynur Abbott"
  },
  {
    "label": "B ACTIVE by Beachlife",
    "value": "B ACTIVE by Beachlife"
  },
  {
    "label": "BCBGeneration",
    "value": "BCBGeneration"
  },
  {
    "label": "BDG Urban Outfitters",
    "value": "BDG Urban Outfitters"
  },
  {
    "label": "BE EDGY",
    "value": "BE EDGY"
  },
  {
    "label": "BEACH TIME",
    "value": "BEACH TIME"
  },
  {
    "label": "BEBO Shop",
    "value": "BEBO Shop"
  },
  {
    "label": "BEBO",
    "value": "BEBO"
  },
  {
    "label": "BELLYBUTTON",
    "value": "BELLYBUTTON"
  },
  {
    "label": "BELMONDO",
    "value": "BELMONDO"
  },
  {
    "label": "BENCH",
    "value": "BENCH"
  },
  {
    "label": "BETTY BOGAERS",
    "value": "BETTY BOGAERS"
  },
  {
    "label": "BIDI BADU",
    "value": "BIDI BADU"
  },
  {
    "label": "BILLABONG",
    "value": "BILLABONG"
  },
  {
    "label": "BIRKENSTOCK",
    "value": "BIRKENSTOCK"
  },
  {
    "label": "BLONDE No. 8",
    "value": "BLONDE No. 8"
  },
  {
    "label": "BOGNER",
    "value": "BOGNER"
  },
  {
    "label": "BOND NO. 9",
    "value": "BOND NO. 9"
  },
  {
    "label": "BOSS",
    "value": "BOSS"
  },
  {
    "label": "BOYSEN'S",
    "value": "BOYSEN'S"
  },
  {
    "label": "BRAEZ",
    "value": "BRAEZ"
  },
  {
    "label": "BRAX",
    "value": "BRAX"
  },
  {
    "label": "BREE",
    "value": "BREE"
  },
  {
    "label": "BRITISH KNIGHTS",
    "value": "BRITISH KNIGHTS"
  },
  {
    "label": "BROADWAY NYC FASHION",
    "value": "BROADWAY NYC FASHION"
  },
  {
    "label": "BRON",
    "value": "BRON"
  },
  {
    "label": "BRONX",
    "value": "BRONX"
  },
  {
    "label": "BRUNO BANANI",
    "value": "BRUNO BANANI"
  },
  {
    "label": "BUFFALO",
    "value": "BUFFALO"
  },
  {
    "label": "BULLBOXER",
    "value": "BULLBOXER"
  },
  {
    "label": "BURBERRY",
    "value": "BURBERRY"
  },
  {
    "label": "BURLINGTON",
    "value": "BURLINGTON"
  },
  {
    "label": "BURTON",
    "value": "BURTON"
  },
  {
    "label": "BY-BAR",
    "value": "BY-BAR"
  },
  {
    "label": "BZR",
    "value": "BZR"
  },
  {
    "label": "Babymel",
    "value": "Babymel"
  },
  {
    "label": "Baku",
    "value": "Baku"
  },
  {
    "label": "Balenciaga",
    "value": "Balenciaga"
  },
  {
    "label": "Bally",
    "value": "Bally"
  },
  {
    "label": "Balmain",
    "value": "Balmain"
  },
  {
    "label": "Banana Moon",
    "value": "Banana Moon"
  },
  {
    "label": "Banana Republic",
    "value": "Banana Republic"
  },
  {
    "label": "Barbara Schwarzer Shop",
    "value": "Barbara Schwarzer Shop"
  },
  {
    "label": "Barbour",
    "value": "Barbour"
  },
  {
    "label": "Bardot",
    "value": "Bardot"
  },
  {
    "label": "Barts",
    "value": "Barts"
  },
  {
    "label": "Bata Heritage",
    "value": "Bata Heritage"
  },
  {
    "label": "Bata",
    "value": "Bata"
  },
  {
    "label": "Baukjen",
    "value": "Baukjen"
  },
  {
    "label": "Baum und Pferdgarten",
    "value": "Baum und Pferdgarten"
  },
  {
    "label": "Baume & Mercier",
    "value": "Baume & Mercier"
  },
  {
    "label": "Be Edgy",
    "value": "Be Edgy"
  },
  {
    "label": "Be Mine",
    "value": "Be Mine"
  },
  {
    "label": "Be Natural",
    "value": "Be Natural"
  },
  {
    "label": "Be Only",
    "value": "Be Only"
  },
  {
    "label": "Beach Riot",
    "value": "Beach Riot"
  },
  {
    "label": "Beachlife",
    "value": "Beachlife"
  },
  {
    "label": "BeckSöndergaard",
    "value": "BeckSöndergaard"
  },
  {
    "label": "BeeDees",
    "value": "BeeDees"
  },
  {
    "label": "Bellerose",
    "value": "Bellerose"
  },
  {
    "label": "Bellfield",
    "value": "Bellfield"
  },
  {
    "label": "Belluna",
    "value": "Belluna"
  },
  {
    "label": "Belstaff",
    "value": "Belstaff"
  },
  {
    "label": "Bench",
    "value": "Bench"
  },
  {
    "label": "Benetton",
    "value": "Benetton"
  },
  {
    "label": "Benjamin Adams",
    "value": "Benjamin Adams"
  },
  {
    "label": "Bensimon",
    "value": "Bensimon"
  },
  {
    "label": "Bergans",
    "value": "Bergans"
  },
  {
    "label": "Berghaus",
    "value": "Berghaus"
  },
  {
    "label": "Bering",
    "value": "Bering"
  },
  {
    "label": "Bernie Mev",
    "value": "Bernie Mev"
  },
  {
    "label": "Bershka",
    "value": "Bershka"
  },
  {
    "label": "Bertie",
    "value": "Bertie"
  },
  {
    "label": "Beth Richards",
    "value": "Beth Richards"
  },
  {
    "label": "Betty & Co",
    "value": "Betty & Co"
  },
  {
    "label": "Beyoncé",
    "value": "Beyoncé"
  },
  {
    "label": "BiB - Tas-in-Tas",
    "value": "BiB - Tas-in-Tas"
  },
  {
    "label": "Bianca Di",
    "value": "Bianca Di"
  },
  {
    "label": "Bianco",
    "value": "Bianco"
  },
  {
    "label": "Bickley + Mitchell",
    "value": "Bickley + Mitchell"
  },
  {
    "label": "Bickley+Mitchell",
    "value": "Bickley+Mitchell"
  },
  {
    "label": "Bik Bok",
    "value": "Bik Bok"
  },
  {
    "label": "Billabong",
    "value": "Billabong"
  },
  {
    "label": "Billi Bi",
    "value": "Billi Bi"
  },
  {
    "label": "Billionaire Boys Club",
    "value": "Billionaire Boys Club"
  },
  {
    "label": "Bio-Oil",
    "value": "Bio-Oil"
  },
  {
    "label": "Biotherm",
    "value": "Biotherm"
  },
  {
    "label": "Birgitte Herskind",
    "value": "Birgitte Herskind"
  },
  {
    "label": "Birkenstock Shop",
    "value": "Birkenstock Shop"
  },
  {
    "label": "Birkenstock",
    "value": "Birkenstock"
  },
  {
    "label": "Björn Borg",
    "value": "Björn Borg"
  },
  {
    "label": "Black Diamond",
    "value": "Black Diamond"
  },
  {
    "label": "Black and gold",
    "value": "Black and gold"
  },
  {
    "label": "Blackroll",
    "value": "Blackroll"
  },
  {
    "label": "Blackstone",
    "value": "Blackstone"
  },
  {
    "label": "Blauer",
    "value": "Blauer"
  },
  {
    "label": "Blend She",
    "value": "Blend She"
  },
  {
    "label": "Blond ACCESSORIES",
    "value": "Blond ACCESSORIES"
  },
  {
    "label": "Blue Life",
    "value": "Blue Life"
  },
  {
    "label": "Blue by Betsey Johnson",
    "value": "Blue by Betsey Johnson"
  },
  {
    "label": "Bluebella",
    "value": "Bluebella"
  },
  {
    "label": "Bluebelle Maternity",
    "value": "Bluebelle Maternity"
  },
  {
    "label": "Blundstone",
    "value": "Blundstone"
  },
  {
    "label": "Blush",
    "value": "Blush"
  },
  {
    "label": "Bobbi Brown",
    "value": "Bobbi Brown"
  },
  {
    "label": "Bogner",
    "value": "Bogner"
  },
  {
    "label": "Bogs",
    "value": "Bogs"
  },
  {
    "label": "Bolzr",
    "value": "Bolzr"
  },
  {
    "label": "Bombers",
    "value": "Bombers"
  },
  {
    "label": "Bomboogie",
    "value": "Bomboogie"
  },
  {
    "label": "Bon Bini",
    "value": "Bon Bini"
  },
  {
    "label": "Bondi Born",
    "value": "Bondi Born"
  },
  {
    "label": "Bonne Maison",
    "value": "Bonne Maison"
  },
  {
    "label": "Bonpoint",
    "value": "Bonpoint"
  },
  {
    "label": "Boob",
    "value": "Boob"
  },
  {
    "label": "Boohoo",
    "value": "Boohoo"
  },
  {
    "label": "Bottega Veneta",
    "value": "Bottega Veneta"
  },
  {
    "label": "Boutique Moschino",
    "value": "Boutique Moschino"
  },
  {
    "label": "Boux Avenue",
    "value": "Boux Avenue"
  },
  {
    "label": "Brador",
    "value": "Brador"
  },
  {
    "label": "Bravado",
    "value": "Bravado"
  },
  {
    "label": "Brax Shop",
    "value": "Brax Shop"
  },
  {
    "label": "Brax",
    "value": "Brax"
  },
  {
    "label": "Bree",
    "value": "Bree"
  },
  {
    "label": "Breil",
    "value": "Breil"
  },
  {
    "label": "Brenda Zaro",
    "value": "Brenda Zaro"
  },
  {
    "label": "Bric's",
    "value": "Bric's"
  },
  {
    "label": "British Knights",
    "value": "British Knights"
  },
  {
    "label": "Brixtol Textiles",
    "value": "Brixtol Textiles"
  },
  {
    "label": "Brixton",
    "value": "Brixton"
  },
  {
    "label": "Bronx",
    "value": "Bronx"
  },
  {
    "label": "Brooklyn's Own by Rocawear",
    "value": "Brooklyn's Own by Rocawear"
  },
  {
    "label": "Brooks England",
    "value": "Brooks England"
  },
  {
    "label": "Bruno Banani",
    "value": "Bruno Banani"
  },
  {
    "label": "Bruno Premi",
    "value": "Bruno Premi"
  },
  {
    "label": "Brunotti",
    "value": "Brunotti"
  },
  {
    "label": "Bruuns Bazaar",
    "value": "Bruuns Bazaar"
  },
  {
    "label": "Buddha to Buddha",
    "value": "Buddha to Buddha"
  },
  {
    "label": "Buff",
    "value": "Buff"
  },
  {
    "label": "Buffalo",
    "value": "Buffalo"
  },
  {
    "label": "Bugatti",
    "value": "Bugatti"
  },
  {
    "label": "Bull Sisters",
    "value": "Bull Sisters"
  },
  {
    "label": "Bullboxer",
    "value": "Bullboxer"
  },
  {
    "label": "Burberry",
    "value": "Burberry"
  },
  {
    "label": "Burlington",
    "value": "Burlington"
  },
  {
    "label": "Burton",
    "value": "Burton"
  },
  {
    "label": "Bvlgari",
    "value": "Bvlgari"
  },
  {
    "label": "By Malene Birger",
    "value": "By Malene Birger"
  },
  {
    "label": "By Malina",
    "value": "By Malina"
  },
  {
    "label": "CAFèNOIR",
    "value": "CAFèNOIR"
  },
  {
    "label": "CALANDO",
    "value": "CALANDO"
  },
  {
    "label": "CALIDA",
    "value": "CALIDA"
  },
  {
    "label": "CALL IT SPRING",
    "value": "CALL IT SPRING"
  },
  {
    "label": "CAMEL ACTIVE",
    "value": "CAMEL ACTIVE"
  },
  {
    "label": "CAPSULE by Simply Be",
    "value": "CAPSULE by Simply Be"
  },
  {
    "label": "CATWALK JUNKIE",
    "value": "CATWALK JUNKIE"
  },
  {
    "label": "CEP",
    "value": "CEP"
  },
  {
    "label": "CHANEL",
    "value": "CHANEL"
  },
  {
    "label": "CHIEMSEE",
    "value": "CHIEMSEE"
  },
  {
    "label": "CHINTI & PARKER",
    "value": "CHINTI & PARKER"
  },
  {
    "label": "CHPO",
    "value": "CHPO"
  },
  {
    "label": "CINQUE",
    "value": "CINQUE"
  },
  {
    "label": "CIRO",
    "value": "CIRO"
  },
  {
    "label": "CITY WALK",
    "value": "CITY WALK"
  },
  {
    "label": "CLEAN",
    "value": "CLEAN"
  },
  {
    "label": "CLOSED",
    "value": "CLOSED"
  },
  {
    "label": "CLUSE",
    "value": "CLUSE"
  },
  {
    "label": "CMP",
    "value": "CMP"
  },
  {
    "label": "CODE-ZERO",
    "value": "CODE-ZERO"
  },
  {
    "label": "CODELLO",
    "value": "CODELLO"
  },
  {
    "label": "COLLEGE",
    "value": "COLLEGE"
  },
  {
    "label": "COLLEZIONE ALESSANDRO",
    "value": "COLLEZIONE ALESSANDRO"
  },
  {
    "label": "COLUMBIA",
    "value": "COLUMBIA"
  },
  {
    "label": "COMMA",
    "value": "COMMA"
  },
  {
    "label": "CONVERSE",
    "value": "CONVERSE"
  },
  {
    "label": "COUNTRY LINE",
    "value": "COUNTRY LINE"
  },
  {
    "label": "CTWLK",
    "value": "CTWLK"
  },
  {
    "label": "CULTURE",
    "value": "CULTURE"
  },
  {
    "label": "CURARE Yogawear",
    "value": "CURARE Yogawear"
  },
  {
    "label": "CVRD",
    "value": "CVRD"
  },
  {
    "label": "CZ by Kenneth Jay Lane",
    "value": "CZ by Kenneth Jay Lane"
  },
  {
    "label": "Ca Shott",
    "value": "Ca Shott"
  },
  {
    "label": "Ca'Shott",
    "value": "Ca'Shott"
  },
  {
    "label": "Cabin Zero",
    "value": "Cabin Zero"
  },
  {
    "label": "Cache Coeur",
    "value": "Cache Coeur"
  },
  {
    "label": "Cadeaupakketten",
    "value": "Cadeaupakketten"
  },
  {
    "label": "Cake Maternity",
    "value": "Cake Maternity"
  },
  {
    "label": "Calida",
    "value": "Calida"
  },
  {
    "label": "Call it Spring",
    "value": "Call it Spring"
  },
  {
    "label": "Calvin Klein",
    "value": "Calvin Klein"
  },
  {
    "label": "Cameo Collective",
    "value": "Cameo Collective"
  },
  {
    "label": "Camper",
    "value": "Camper"
  },
  {
    "label": "Campomaggi",
    "value": "Campomaggi"
  },
  {
    "label": "Camps & Camps",
    "value": "Camps & Camps"
  },
  {
    "label": "Canada Goose",
    "value": "Canada Goose"
  },
  {
    "label": "Canadian Classics",
    "value": "Canadian Classics"
  },
  {
    "label": "Candice Cooper",
    "value": "Candice Cooper"
  },
  {
    "label": "Caprice",
    "value": "Caprice"
  },
  {
    "label": "Carhartt WIP",
    "value": "Carhartt WIP"
  },
  {
    "label": "Carmela",
    "value": "Carmela"
  },
  {
    "label": "Carolina Cavour",
    "value": "Carolina Cavour"
  },
  {
    "label": "Carrera",
    "value": "Carrera"
  },
  {
    "label": "Cartier",
    "value": "Cartier"
  },
  {
    "label": "Cartoon",
    "value": "Cartoon"
  },
  {
    "label": "Carvela Comfort",
    "value": "Carvela Comfort"
  },
  {
    "label": "Carvela",
    "value": "Carvela"
  },
  {
    "label": "Casa Jewelry",
    "value": "Casa Jewelry"
  },
  {
    "label": "Casadei",
    "value": "Casadei"
  },
  {
    "label": "Casall",
    "value": "Casall"
  },
  {
    "label": "Casio",
    "value": "Casio"
  },
  {
    "label": "Cassis côte d'azur",
    "value": "Cassis côte d'azur"
  },
  {
    "label": "Castañer",
    "value": "Castañer"
  },
  {
    "label": "Castelijn & Beerens",
    "value": "Castelijn & Beerens"
  },
  {
    "label": "Catarina Martins",
    "value": "Catarina Martins"
  },
  {
    "label": "Caterpillar",
    "value": "Caterpillar"
  },
  {
    "label": "Cath Kidston",
    "value": "Cath Kidston"
  },
  {
    "label": "Cecil",
    "value": "Cecil"
  },
  {
    "label": "Cerruti",
    "value": "Cerruti"
  },
  {
    "label": "Certina",
    "value": "Certina"
  },
  {
    "label": "Chalmers",
    "value": "Chalmers"
  },
  {
    "label": "Champion Authentic Athletic Apparel",
    "value": "Champion Authentic Athletic Apparel"
  },
  {
    "label": "Champion Reverse Weave",
    "value": "Champion Reverse Weave"
  },
  {
    "label": "Champion Shop",
    "value": "Champion Shop"
  },
  {
    "label": "Champion",
    "value": "Champion"
  },
  {
    "label": "Chantal Thomass",
    "value": "Chantal Thomass"
  },
  {
    "label": "Chantelle",
    "value": "Chantelle"
  },
  {
    "label": "Charlotte Tilbury",
    "value": "Charlotte Tilbury"
  },
  {
    "label": "Chasin'",
    "value": "Chasin'"
  },
  {
    "label": "Cheap Monday",
    "value": "Cheap Monday"
  },
  {
    "label": "Chelsea Peers",
    "value": "Chelsea Peers"
  },
  {
    "label": "Chi Chi Curve",
    "value": "Chi Chi Curve"
  },
  {
    "label": "Chi Chi London",
    "value": "Chi Chi London"
  },
  {
    "label": "Chie Mihara",
    "value": "Chie Mihara"
  },
  {
    "label": "Chie",
    "value": "Chie"
  },
  {
    "label": "Chiemsee",
    "value": "Chiemsee"
  },
  {
    "label": "Chillouts",
    "value": "Chillouts"
  },
  {
    "label": "Chimi",
    "value": "Chimi"
  },
  {
    "label": "Chinese Laundry",
    "value": "Chinese Laundry"
  },
  {
    "label": "Chloe Stora",
    "value": "Chloe Stora"
  },
  {
    "label": "Chloé",
    "value": "Chloé"
  },
  {
    "label": "Christian Lacroix",
    "value": "Christian Lacroix"
  },
  {
    "label": "Christina Aguilera",
    "value": "Christina Aguilera"
  },
  {
    "label": "Christophe Robin",
    "value": "Christophe Robin"
  },
  {
    "label": "Chrome Industries",
    "value": "Chrome Industries"
  },
  {
    "label": "Cimarron",
    "value": "Cimarron"
  },
  {
    "label": "Cinque",
    "value": "Cinque"
  },
  {
    "label": "Circle of Trust",
    "value": "Circle of Trust"
  },
  {
    "label": "Citizens of Humanity",
    "value": "Citizens of Humanity"
  },
  {
    "label": "City Chic",
    "value": "City Chic"
  },
  {
    "label": "Clae",
    "value": "Clae"
  },
  {
    "label": "Claes Iversen",
    "value": "Claes Iversen"
  },
  {
    "label": "Claesen's Basics",
    "value": "Claesen's Basics"
  },
  {
    "label": "Clarins",
    "value": "Clarins"
  },
  {
    "label": "Clarks",
    "value": "Clarks"
  },
  {
    "label": "Classic Crafters",
    "value": "Classic Crafters"
  },
  {
    "label": "Claudia Sträter",
    "value": "Claudia Sträter"
  },
  {
    "label": "Claudie Pierlot",
    "value": "Claudie Pierlot"
  },
  {
    "label": "Cleo",
    "value": "Cleo"
  },
  {
    "label": "Cleptomanicx",
    "value": "Cleptomanicx"
  },
  {
    "label": "Clinique",
    "value": "Clinique"
  },
  {
    "label": "Closed",
    "value": "Closed"
  },
  {
    "label": "Closet",
    "value": "Closet"
  },
  {
    "label": "Club L London",
    "value": "Club L London"
  },
  {
    "label": "Club Monaco",
    "value": "Club Monaco"
  },
  {
    "label": "Coach 1941",
    "value": "Coach 1941"
  },
  {
    "label": "Coach",
    "value": "Coach"
  },
  {
    "label": "Coast Shop",
    "value": "Coast Shop"
  },
  {
    "label": "Coast",
    "value": "Coast"
  },
  {
    "label": "Coccinelle",
    "value": "Coccinelle"
  },
  {
    "label": "Codello",
    "value": "Codello"
  },
  {
    "label": "Collonil",
    "value": "Collonil"
  },
  {
    "label": "Colmar Originals",
    "value": "Colmar Originals"
  },
  {
    "label": "Colmar Shop",
    "value": "Colmar Shop"
  },
  {
    "label": "Colmar",
    "value": "Colmar"
  },
  {
    "label": "Colors of California",
    "value": "Colors of California"
  },
  {
    "label": "Colourful Rebel",
    "value": "Colourful Rebel"
  },
  {
    "label": "Columbia",
    "value": "Columbia"
  },
  {
    "label": "Comme des Garçons",
    "value": "Comme des Garçons"
  },
  {
    "label": "Compañía fantástica",
    "value": "Compañía fantástica"
  },
  {
    "label": "Comptoir Sud Pacifique",
    "value": "Comptoir Sud Pacifique"
  },
  {
    "label": "Connoisseurs",
    "value": "Connoisseurs"
  },
  {
    "label": "Converse Shop",
    "value": "Converse Shop"
  },
  {
    "label": "Converse",
    "value": "Converse"
  },
  {
    "label": "Coolway Freestyle",
    "value": "Coolway Freestyle"
  },
  {
    "label": "Coolway",
    "value": "Coolway"
  },
  {
    "label": "Copenhagen",
    "value": "Copenhagen"
  },
  {
    "label": "Coral Blue",
    "value": "Coral Blue"
  },
  {
    "label": "Corte Della Pelle",
    "value": "Corte Della Pelle"
  },
  {
    "label": "Cortefiel",
    "value": "Cortefiel"
  },
  {
    "label": "Cosabella Shop",
    "value": "Cosabella Shop"
  },
  {
    "label": "Cosabella",
    "value": "Cosabella"
  },
  {
    "label": "Cosmoparis",
    "value": "Cosmoparis"
  },
  {
    "label": "Costume National",
    "value": "Costume National"
  },
  {
    "label": "Covert Overt",
    "value": "Covert Overt"
  },
  {
    "label": "Cowboysbag",
    "value": "Cowboysbag"
  },
  {
    "label": "Cowboysbelt Shop",
    "value": "Cowboysbelt Shop"
  },
  {
    "label": "Craft",
    "value": "Craft"
  },
  {
    "label": "Craghoppers",
    "value": "Craghoppers"
  },
  {
    "label": "Craie",
    "value": "Craie"
  },
  {
    "label": "Cream",
    "value": "Cream"
  },
  {
    "label": "Creed",
    "value": "Creed"
  },
  {
    "label": "Creenstone",
    "value": "Creenstone"
  },
  {
    "label": "Crisp Sheets",
    "value": "Crisp Sheets"
  },
  {
    "label": "Crocs",
    "value": "Crocs"
  },
  {
    "label": "Cross Jeans",
    "value": "Cross Jeans"
  },
  {
    "label": "Crumpler",
    "value": "Crumpler"
  },
  {
    "label": "Culture",
    "value": "Culture"
  },
  {
    "label": "Curare Yogawear",
    "value": "Curare Yogawear"
  },
  {
    "label": "Current/Elliott",
    "value": "Current/Elliott"
  },
  {
    "label": "Curvy Kate",
    "value": "Curvy Kate"
  },
  {
    "label": "Custommade",
    "value": "Custommade"
  },
  {
    "label": "Cyell",
    "value": "Cyell"
  },
  {
    "label": "Cypres",
    "value": "Cypres"
  },
  {
    "label": "Côte&Ciel",
    "value": "Côte&Ciel"
  },
  {
    "label": "D.A.T.E.",
    "value": "D.A.T.E."
  },
  {
    "label": "DAKINE",
    "value": "DAKINE"
  },
  {
    "label": "DANIEL HECHTER",
    "value": "DANIEL HECHTER"
  },
  {
    "label": "DAY Birger et Mikkelsen",
    "value": "DAY Birger et Mikkelsen"
  },
  {
    "label": "DAY Shop",
    "value": "DAY Shop"
  },
  {
    "label": "DC Shoes",
    "value": "DC Shoes"
  },
  {
    "label": "DENHAM",
    "value": "DENHAM"
  },
  {
    "label": "DEPECHE",
    "value": "DEPECHE"
  },
  {
    "label": "DEPECHE.",
    "value": "DEPECHE."
  },
  {
    "label": "DESIGNERS REMIX",
    "value": "DESIGNERS REMIX"
  },
  {
    "label": "DIDRIKSONS1913",
    "value": "DIDRIKSONS1913"
  },
  {
    "label": "DIESEL",
    "value": "DIESEL"
  },
  {
    "label": "DIM",
    "value": "DIM"
  },
  {
    "label": "DIOR",
    "value": "DIOR"
  },
  {
    "label": "DISEE",
    "value": "DISEE"
  },
  {
    "label": "DKNY Intimates",
    "value": "DKNY Intimates"
  },
  {
    "label": "DKNY Minute",
    "value": "DKNY Minute"
  },
  {
    "label": "DKNY",
    "value": "DKNY"
  },
  {
    "label": "DNA Footwear BV",
    "value": "DNA Footwear BV"
  },
  {
    "label": "DNA",
    "value": "DNA"
  },
  {
    "label": "DP Maternity",
    "value": "DP Maternity"
  },
  {
    "label": "DREIMASTER",
    "value": "DREIMASTER"
  },
  {
    "label": "DRYKORN",
    "value": "DRYKORN"
  },
  {
    "label": "DUNE LONDON Shop",
    "value": "DUNE LONDON Shop"
  },
  {
    "label": "Dachstein",
    "value": "Dachstein"
  },
  {
    "label": "Daily Paper",
    "value": "Daily Paper"
  },
  {
    "label": "Daisy Street Plus",
    "value": "Daisy Street Plus"
  },
  {
    "label": "Daisy Street",
    "value": "Daisy Street"
  },
  {
    "label": "Dakine",
    "value": "Dakine"
  },
  {
    "label": "Dale of Norway",
    "value": "Dale of Norway"
  },
  {
    "label": "Danefæ København",
    "value": "Danefæ København"
  },
  {
    "label": "Daniel Hechter",
    "value": "Daniel Hechter"
  },
  {
    "label": "Daniel Wellington",
    "value": "Daniel Wellington"
  },
  {
    "label": "Danish Design",
    "value": "Danish Design"
  },
  {
    "label": "Dante 6",
    "value": "Dante 6"
  },
  {
    "label": "Dante6",
    "value": "Dante6"
  },
  {
    "label": "Dare 2B",
    "value": "Dare 2B"
  },
  {
    "label": "Darkwood",
    "value": "Darkwood"
  },
  {
    "label": "Day Birger et Mikkelsen",
    "value": "Day Birger et Mikkelsen"
  },
  {
    "label": "De Marchi",
    "value": "De Marchi"
  },
  {
    "label": "Dear Denier",
    "value": "Dear Denier"
  },
  {
    "label": "Deby Debo",
    "value": "Deby Debo"
  },
  {
    "label": "Decadent",
    "value": "Decadent"
  },
  {
    "label": "Deha",
    "value": "Deha"
  },
  {
    "label": "Delicatelove",
    "value": "Delicatelove"
  },
  {
    "label": "Delsey",
    "value": "Delsey"
  },
  {
    "label": "Denham",
    "value": "Denham"
  },
  {
    "label": "Denim & Supply Ralph Lauren",
    "value": "Denim & Supply Ralph Lauren"
  },
  {
    "label": "Denim is Dead",
    "value": "Denim is Dead"
  },
  {
    "label": "Derbe",
    "value": "Derbe"
  },
  {
    "label": "Derek Lam 10 Crosby",
    "value": "Derek Lam 10 Crosby"
  },
  {
    "label": "Derek Lam Shop",
    "value": "Derek Lam Shop"
  },
  {
    "label": "Derhy",
    "value": "Derhy"
  },
  {
    "label": "Dermalogica",
    "value": "Dermalogica"
  },
  {
    "label": "Desigual",
    "value": "Desigual"
  },
  {
    "label": "Desires",
    "value": "Desires"
  },
  {
    "label": "Devotion",
    "value": "Devotion"
  },
  {
    "label": "Diadora Shop",
    "value": "Diadora Shop"
  },
  {
    "label": "Diadora",
    "value": "Diadora"
  },
  {
    "label": "Diamond Point",
    "value": "Diamond Point"
  },
  {
    "label": "Diane von Furstenberg",
    "value": "Diane von Furstenberg"
  },
  {
    "label": "Dickies",
    "value": "Dickies"
  },
  {
    "label": "Didriksons",
    "value": "Didriksons"
  },
  {
    "label": "Diesel Shop",
    "value": "Diesel Shop"
  },
  {
    "label": "Diesel",
    "value": "Diesel"
  },
  {
    "label": "Dimensione Danza",
    "value": "Dimensione Danza"
  },
  {
    "label": "Divine Factory",
    "value": "Divine Factory"
  },
  {
    "label": "Djinn's",
    "value": "Djinn's"
  },
  {
    "label": "Dockers by Gerli",
    "value": "Dockers by Gerli"
  },
  {
    "label": "Dolce & Gabbana",
    "value": "Dolce & Gabbana"
  },
  {
    "label": "Dolce Vita",
    "value": "Dolce Vita"
  },
  {
    "label": "Dolce&Gabbana Shop",
    "value": "Dolce&Gabbana Shop"
  },
  {
    "label": "Dolce&Gabbana",
    "value": "Dolce&Gabbana"
  },
  {
    "label": "Donna Carolina",
    "value": "Donna Carolina"
  },
  {
    "label": "Donna Karan Hosiery",
    "value": "Donna Karan Hosiery"
  },
  {
    "label": "Dora Larsen",
    "value": "Dora Larsen"
  },
  {
    "label": "Dorina Curves",
    "value": "Dorina Curves"
  },
  {
    "label": "Dorina",
    "value": "Dorina"
  },
  {
    "label": "Dorothy Perkins",
    "value": "Dorothy Perkins"
  },
  {
    "label": "Double Agent",
    "value": "Double Agent"
  },
  {
    "label": "Doughnut",
    "value": "Doughnut"
  },
  {
    "label": "Dr Denim",
    "value": "Dr Denim"
  },
  {
    "label": "Dr Jackson's",
    "value": "Dr Jackson's"
  },
  {
    "label": "Dr Sebagh",
    "value": "Dr Sebagh"
  },
  {
    "label": "Dr. Denim",
    "value": "Dr. Denim"
  },
  {
    "label": "Dr. Hauschka",
    "value": "Dr. Hauschka"
  },
  {
    "label": "Dr. Lipp",
    "value": "Dr. Lipp"
  },
  {
    "label": "Dr. Martens",
    "value": "Dr. Martens"
  },
  {
    "label": "Dr.Denim",
    "value": "Dr.Denim"
  },
  {
    "label": "Drake's",
    "value": "Drake's"
  },
  {
    "label": "Dranella",
    "value": "Dranella"
  },
  {
    "label": "Dreimaster",
    "value": "Dreimaster"
  },
  {
    "label": "Dry Lake",
    "value": "Dry Lake"
  },
  {
    "label": "Dry Laundry",
    "value": "Dry Laundry"
  },
  {
    "label": "Drykorn",
    "value": "Drykorn"
  },
  {
    "label": "Dsquared2",
    "value": "Dsquared2"
  },
  {
    "label": "Due Punti",
    "value": "Due Punti"
  },
  {
    "label": "Dune LONDON",
    "value": "Dune LONDON"
  },
  {
    "label": "Dune London WIDE FIT",
    "value": "Dune London WIDE FIT"
  },
  {
    "label": "Dune London",
    "value": "Dune London"
  },
  {
    "label": "Duvetica",
    "value": "Duvetica"
  },
  {
    "label": "Dynafit",
    "value": "Dynafit"
  },
  {
    "label": "Dyrberg/Kern",
    "value": "Dyrberg/Kern"
  },
  {
    "label": "Dyson",
    "value": "Dyson"
  },
  {
    "label": "Döll",
    "value": "Döll"
  },
  {
    "label": "E8 BY MIISTA",
    "value": "E8 BY MIISTA"
  },
  {
    "label": "EA7 Emporio Armani",
    "value": "EA7 Emporio Armani"
  },
  {
    "label": "EASTPAK",
    "value": "EASTPAK"
  },
  {
    "label": "EASTWIND",
    "value": "EASTWIND"
  },
  {
    "label": "ECOALF",
    "value": "ECOALF"
  },
  {
    "label": "EDC BY ESPRIT",
    "value": "EDC BY ESPRIT"
  },
  {
    "label": "EDITED",
    "value": "EDITED"
  },
  {
    "label": "EGO",
    "value": "EGO"
  },
  {
    "label": "EINSTEIN & NEWTON",
    "value": "EINSTEIN & NEWTON"
  },
  {
    "label": "ELEMENT",
    "value": "ELEMENT"
  },
  {
    "label": "ELLESSE",
    "value": "ELLESSE"
  },
  {
    "label": "EMU Australia",
    "value": "EMU Australia"
  },
  {
    "label": "ERASE",
    "value": "ERASE"
  },
  {
    "label": "ESPRIT SPORTS",
    "value": "ESPRIT SPORTS"
  },
  {
    "label": "ESPRIT",
    "value": "ESPRIT"
  },
  {
    "label": "ETERNA",
    "value": "ETERNA"
  },
  {
    "label": "ETNIES",
    "value": "ETNIES"
  },
  {
    "label": "EVITA",
    "value": "EVITA"
  },
  {
    "label": "Each x Other",
    "value": "Each x Other"
  },
  {
    "label": "Eastpak",
    "value": "Eastpak"
  },
  {
    "label": "Eberjey",
    "value": "Eberjey"
  },
  {
    "label": "Edith and Ella",
    "value": "Edith and Ella"
  },
  {
    "label": "Effzeh",
    "value": "Effzeh"
  },
  {
    "label": "Egyptian Magic",
    "value": "Egyptian Magic"
  },
  {
    "label": "Eider",
    "value": "Eider"
  },
  {
    "label": "Eisbär",
    "value": "Eisbär"
  },
  {
    "label": "Eivy",
    "value": "Eivy"
  },
  {
    "label": "El Naturalista",
    "value": "El Naturalista"
  },
  {
    "label": "Element",
    "value": "Element"
  },
  {
    "label": "Elie Saab",
    "value": "Elie Saab"
  },
  {
    "label": "Elie Tahari",
    "value": "Elie Tahari"
  },
  {
    "label": "Elisabetta Franchi",
    "value": "Elisabetta Franchi"
  },
  {
    "label": "Elizabeth Arden",
    "value": "Elizabeth Arden"
  },
  {
    "label": "Elizabeth and James",
    "value": "Elizabeth and James"
  },
  {
    "label": "Elle Sport",
    "value": "Elle Sport"
  },
  {
    "label": "Ellen Beekmans",
    "value": "Ellen Beekmans"
  },
  {
    "label": "Ellen Truijen",
    "value": "Ellen Truijen"
  },
  {
    "label": "Ellesse",
    "value": "Ellesse"
  },
  {
    "label": "Elli",
    "value": "Elli"
  },
  {
    "label": "Elomi",
    "value": "Elomi"
  },
  {
    "label": "Else",
    "value": "Else"
  },
  {
    "label": "Elvi",
    "value": "Elvi"
  },
  {
    "label": "Elvine",
    "value": "Elvine"
  },
  {
    "label": "Emilia Lay",
    "value": "Emilia Lay"
  },
  {
    "label": "Emily & Noah",
    "value": "Emily & Noah"
  },
  {
    "label": "Emily van den Bergh",
    "value": "Emily van den Bergh"
  },
  {
    "label": "Emporio Armani Connected",
    "value": "Emporio Armani Connected"
  },
  {
    "label": "Emporio Armani",
    "value": "Emporio Armani"
  },
  {
    "label": "Endless Rose",
    "value": "Endless Rose"
  },
  {
    "label": "Enes",
    "value": "Enes"
  },
  {
    "label": "English Factory",
    "value": "English Factory"
  },
  {
    "label": "Enter",
    "value": "Enter"
  },
  {
    "label": "Envie de Fraise",
    "value": "Envie de Fraise"
  },
  {
    "label": "Envii",
    "value": "Envii"
  },
  {
    "label": "Equipment",
    "value": "Equipment"
  },
  {
    "label": "Erika Rocchi",
    "value": "Erika Rocchi"
  },
  {
    "label": "Erima",
    "value": "Erima"
  },
  {
    "label": "Escada Shop",
    "value": "Escada Shop"
  },
  {
    "label": "Escada Sport",
    "value": "Escada Sport"
  },
  {
    "label": "Escada",
    "value": "Escada"
  },
  {
    "label": "Escentric Molecules",
    "value": "Escentric Molecules"
  },
  {
    "label": "Eshvi",
    "value": "Eshvi"
  },
  {
    "label": "Espadrij l´originale",
    "value": "Espadrij l´originale"
  },
  {
    "label": "Esprit",
    "value": "Esprit"
  },
  {
    "label": "Essentiel Antwerp",
    "value": "Essentiel Antwerp"
  },
  {
    "label": "Essenza",
    "value": "Essenza"
  },
  {
    "label": "Estella Bartlett",
    "value": "Estella Bartlett"
  },
  {
    "label": "Estée Lauder",
    "value": "Estée Lauder"
  },
  {
    "label": "Eterna",
    "value": "Eterna"
  },
  {
    "label": "Etnies",
    "value": "Etnies"
  },
  {
    "label": "Etro",
    "value": "Etro"
  },
  {
    "label": "Eulenschnitt",
    "value": "Eulenschnitt"
  },
  {
    "label": "Evans",
    "value": "Evans"
  },
  {
    "label": "Even&Odd",
    "value": "Even&Odd"
  },
  {
    "label": "Everybody",
    "value": "Everybody"
  },
  {
    "label": "Evita",
    "value": "Evita"
  },
  {
    "label": "Ewers",
    "value": "Ewers"
  },
  {
    "label": "Exo Eyewear",
    "value": "Exo Eyewear"
  },
  {
    "label": "Expresso",
    "value": "Expresso"
  },
  {
    "label": "Exé",
    "value": "Exé"
  },
  {
    "label": "Eytys",
    "value": "Eytys"
  },
  {
    "label": "Ezekiel",
    "value": "Ezekiel"
  },
  {
    "label": "FALKE",
    "value": "FALKE"
  },
  {
    "label": "FILA",
    "value": "FILA"
  },
  {
    "label": "FIORELLI",
    "value": "FIORELLI"
  },
  {
    "label": "FIVEUNITS",
    "value": "FIVEUNITS"
  },
  {
    "label": "FLIP*FLOP",
    "value": "FLIP*FLOP"
  },
  {
    "label": "FOSSIL",
    "value": "FOSSIL"
  },
  {
    "label": "FREAKY NATION",
    "value": "FREAKY NATION"
  },
  {
    "label": "FREDsBRUDER",
    "value": "FREDsBRUDER"
  },
  {
    "label": "FRENCH CONNECTION",
    "value": "FRENCH CONNECTION"
  },
  {
    "label": "FTC Cashmere",
    "value": "FTC Cashmere"
  },
  {
    "label": "FWSS",
    "value": "FWSS"
  },
  {
    "label": "Fabienne Chapot",
    "value": "Fabienne Chapot"
  },
  {
    "label": "Faith Wide Fit",
    "value": "Faith Wide Fit"
  },
  {
    "label": "Faith",
    "value": "Faith"
  },
  {
    "label": "Falke",
    "value": "Falke"
  },
  {
    "label": "Falke® Dames",
    "value": "Falke® Dames"
  },
  {
    "label": "Fantasie",
    "value": "Fantasie"
  },
  {
    "label": "Farina Opoku",
    "value": "Farina Opoku"
  },
  {
    "label": "Fashion Union",
    "value": "Fashion Union"
  },
  {
    "label": "Fashionology",
    "value": "Fashionology"
  },
  {
    "label": "Felmini",
    "value": "Felmini"
  },
  {
    "label": "Femmes du Sud",
    "value": "Femmes du Sud"
  },
  {
    "label": "Fendi",
    "value": "Fendi"
  },
  {
    "label": "Fenty PUMA by Rihanna",
    "value": "Fenty PUMA by Rihanna"
  },
  {
    "label": "Feraggio",
    "value": "Feraggio"
  },
  {
    "label": "Fersengold",
    "value": "Fersengold"
  },
  {
    "label": "Fifth House",
    "value": "Fifth House"
  },
  {
    "label": "Fila Petite",
    "value": "Fila Petite"
  },
  {
    "label": "Fila Shop",
    "value": "Fila Shop"
  },
  {
    "label": "Fila Tall",
    "value": "Fila Tall"
  },
  {
    "label": "Fila",
    "value": "Fila"
  },
  {
    "label": "Filippa K",
    "value": "Filippa K"
  },
  {
    "label": "Filling Pieces",
    "value": "Filling Pieces"
  },
  {
    "label": "Fine Edge",
    "value": "Fine Edge"
  },
  {
    "label": "Fine Paris",
    "value": "Fine Paris"
  },
  {
    "label": "Finery London",
    "value": "Finery London"
  },
  {
    "label": "Finn Flare",
    "value": "Finn Flare"
  },
  {
    "label": "Fiore di Lucia Milano",
    "value": "Fiore di Lucia Milano"
  },
  {
    "label": "Fiorelli",
    "value": "Fiorelli"
  },
  {
    "label": "Fiorucci",
    "value": "Fiorucci"
  },
  {
    "label": "First and I",
    "value": "First and I"
  },
  {
    "label": "FitFlop",
    "value": "FitFlop"
  },
  {
    "label": "Fitters",
    "value": "Fitters"
  },
  {
    "label": "Fiveunits",
    "value": "Fiveunits"
  },
  {
    "label": "Fjällräven",
    "value": "Fjällräven"
  },
  {
    "label": "Flexfit",
    "value": "Flexfit"
  },
  {
    "label": "Foamie",
    "value": "Foamie"
  },
  {
    "label": "Fogal",
    "value": "Fogal"
  },
  {
    "label": "For Love & Lemons",
    "value": "For Love & Lemons"
  },
  {
    "label": "Forever Fit",
    "value": "Forever Fit"
  },
  {
    "label": "Forever New Shop",
    "value": "Forever New Shop"
  },
  {
    "label": "Forever New",
    "value": "Forever New"
  },
  {
    "label": "Forever Unique",
    "value": "Forever Unique"
  },
  {
    "label": "Fornarina",
    "value": "Fornarina"
  },
  {
    "label": "Forte Forte",
    "value": "Forte Forte"
  },
  {
    "label": "Forvert",
    "value": "Forvert"
  },
  {
    "label": "Fossil",
    "value": "Fossil"
  },
  {
    "label": "Four Flavor",
    "value": "Four Flavor"
  },
  {
    "label": "Foxiedox",
    "value": "Foxiedox"
  },
  {
    "label": "Fraas",
    "value": "Fraas"
  },
  {
    "label": "Fracomina",
    "value": "Fracomina"
  },
  {
    "label": "Frame Denim",
    "value": "Frame Denim"
  },
  {
    "label": "Francesco Milano",
    "value": "Francesco Milano"
  },
  {
    "label": "Franco Russo Napoli",
    "value": "Franco Russo Napoli"
  },
  {
    "label": "Fransa",
    "value": "Fransa"
  },
  {
    "label": "Fratelli Rossetti",
    "value": "Fratelli Rossetti"
  },
  {
    "label": "Freaky Nation",
    "value": "Freaky Nation"
  },
  {
    "label": "Fred de la Bretoniere",
    "value": "Fred de la Bretoniere"
  },
  {
    "label": "Fred de la Bretonière",
    "value": "Fred de la Bretonière"
  },
  {
    "label": "Frederique Constant",
    "value": "Frederique Constant"
  },
  {
    "label": "Free People",
    "value": "Free People"
  },
  {
    "label": "Freeman T. Porter",
    "value": "Freeman T. Porter"
  },
  {
    "label": "Freequent",
    "value": "Freequent"
  },
  {
    "label": "Fremaux",
    "value": "Fremaux"
  },
  {
    "label": "French Connection",
    "value": "French Connection"
  },
  {
    "label": "French Disorder",
    "value": "French Disorder"
  },
  {
    "label": "Fresh 'n Rebel",
    "value": "Fresh 'n Rebel"
  },
  {
    "label": "Freya",
    "value": "Freya"
  },
  {
    "label": "Friday's Project",
    "value": "Friday's Project"
  },
  {
    "label": "Frieda & Freddies",
    "value": "Frieda & Freddies"
  },
  {
    "label": "Fritzi aus Preußen",
    "value": "Fritzi aus Preußen"
  },
  {
    "label": "Frock and Frill",
    "value": "Frock and Frill"
  },
  {
    "label": "Frogbox",
    "value": "Frogbox"
  },
  {
    "label": "Fromanteel",
    "value": "Fromanteel"
  },
  {
    "label": "Fulton",
    "value": "Fulton"
  },
  {
    "label": "Funkita",
    "value": "Funkita"
  },
  {
    "label": "Funky Buddha",
    "value": "Funky Buddha"
  },
  {
    "label": "Furla",
    "value": "Furla"
  },
  {
    "label": "G-Lab",
    "value": "G-Lab"
  },
  {
    "label": "G-STAR RAW",
    "value": "G-STAR RAW"
  },
  {
    "label": "G-Shock",
    "value": "G-Shock"
  },
  {
    "label": "G-Star RAW",
    "value": "G-Star RAW"
  },
  {
    "label": "G-Star",
    "value": "G-Star"
  },
  {
    "label": "G-shock",
    "value": "G-shock"
  },
  {
    "label": "G. H. Bass & Co.",
    "value": "G. H. Bass & Co."
  },
  {
    "label": "G.H. Bass & Co",
    "value": "G.H. Bass & Co"
  },
  {
    "label": "G.I.G.A. DX",
    "value": "G.I.G.A. DX"
  },
  {
    "label": "GABOR",
    "value": "GABOR"
  },
  {
    "label": "GAI + LISVA",
    "value": "GAI + LISVA"
  },
  {
    "label": "GANT",
    "value": "GANT"
  },
  {
    "label": "GAP Maternity",
    "value": "GAP Maternity"
  },
  {
    "label": "GAP",
    "value": "GAP"
  },
  {
    "label": "GARCIA",
    "value": "GARCIA"
  },
  {
    "label": "GARMENT PROJECT",
    "value": "GARMENT PROJECT"
  },
  {
    "label": "GAS Shop",
    "value": "GAS Shop"
  },
  {
    "label": "GAS",
    "value": "GAS"
  },
  {
    "label": "GEDEBE",
    "value": "GEDEBE"
  },
  {
    "label": "GEORGE GINA & LUCY girls",
    "value": "GEORGE GINA & LUCY girls"
  },
  {
    "label": "GEOX",
    "value": "GEOX"
  },
  {
    "label": "GIL BRET",
    "value": "GIL BRET"
  },
  {
    "label": "GINETTE NY",
    "value": "GINETTE NY"
  },
  {
    "label": "GLAMOROUS",
    "value": "GLAMOROUS"
  },
  {
    "label": "GREYSTONE",
    "value": "GREYSTONE"
  },
  {
    "label": "GUESS",
    "value": "GUESS"
  },
  {
    "label": "GUM Gianni Chiarini design",
    "value": "GUM Gianni Chiarini design"
  },
  {
    "label": "GUSTAV",
    "value": "GUSTAV"
  },
  {
    "label": "Gaastra Shop",
    "value": "Gaastra Shop"
  },
  {
    "label": "Gaastra",
    "value": "Gaastra"
  },
  {
    "label": "Gabor",
    "value": "Gabor"
  },
  {
    "label": "Gabriele",
    "value": "Gabriele"
  },
  {
    "label": "Gabrielle by Molly Bracken",
    "value": "Gabrielle by Molly Bracken"
  },
  {
    "label": "Gadea",
    "value": "Gadea"
  },
  {
    "label": "Gang",
    "value": "Gang"
  },
  {
    "label": "Ganni",
    "value": "Ganni"
  },
  {
    "label": "Gant Shop",
    "value": "Gant Shop"
  },
  {
    "label": "Gant",
    "value": "Gant"
  },
  {
    "label": "Gardenia",
    "value": "Gardenia"
  },
  {
    "label": "Garment Project",
    "value": "Garment Project"
  },
  {
    "label": "Garmin",
    "value": "Garmin"
  },
  {
    "label": "Gas Bijoux",
    "value": "Gas Bijoux"
  },
  {
    "label": "Gaudi",
    "value": "Gaudi"
  },
  {
    "label": "Gc Watches",
    "value": "Gc Watches"
  },
  {
    "label": "Gear4",
    "value": "Gear4"
  },
  {
    "label": "Gebe",
    "value": "Gebe"
  },
  {
    "label": "Genuins",
    "value": "Genuins"
  },
  {
    "label": "Georg Jensen",
    "value": "Georg Jensen"
  },
  {
    "label": "George Gina & Lucy",
    "value": "George Gina & Lucy"
  },
  {
    "label": "Geox",
    "value": "Geox"
  },
  {
    "label": "Gerry Weber",
    "value": "Gerry Weber"
  },
  {
    "label": "Gestuz",
    "value": "Gestuz"
  },
  {
    "label": "Gianvito Rossi",
    "value": "Gianvito Rossi"
  },
  {
    "label": "Giesswein",
    "value": "Giesswein"
  },
  {
    "label": "Gilly Hicks",
    "value": "Gilly Hicks"
  },
  {
    "label": "Gina Tricot",
    "value": "Gina Tricot"
  },
  {
    "label": "Giorgio Armani Beauty",
    "value": "Giorgio Armani Beauty"
  },
  {
    "label": "Giorgio Armani",
    "value": "Giorgio Armani"
  },
  {
    "label": "Giorgio",
    "value": "Giorgio"
  },
  {
    "label": "Gioseppo",
    "value": "Gioseppo"
  },
  {
    "label": "Gipsy",
    "value": "Gipsy"
  },
  {
    "label": "Giro",
    "value": "Giro"
  },
  {
    "label": "Giulia Taddeucci",
    "value": "Giulia Taddeucci"
  },
  {
    "label": "Giuseppe Zanotti",
    "value": "Giuseppe Zanotti"
  },
  {
    "label": "Givenchy",
    "value": "Givenchy"
  },
  {
    "label": "Glamorous",
    "value": "Glamorous"
  },
  {
    "label": "Glide Soul",
    "value": "Glide Soul"
  },
  {
    "label": "Goldbergh",
    "value": "Goldbergh"
  },
  {
    "label": "Goldie London",
    "value": "Goldie London"
  },
  {
    "label": "Goosecraft",
    "value": "Goosecraft"
  },
  {
    "label": "Gore Bike Wear",
    "value": "Gore Bike Wear"
  },
  {
    "label": "Gore Wear",
    "value": "Gore Wear"
  },
  {
    "label": "Gossard",
    "value": "Gossard"
  },
  {
    "label": "Gottex",
    "value": "Gottex"
  },
  {
    "label": "Grace",
    "value": "Grace"
  },
  {
    "label": "Graumann",
    "value": "Graumann"
  },
  {
    "label": "Great Plains",
    "value": "Great Plains"
  },
  {
    "label": "Greenburry",
    "value": "Greenburry"
  },
  {
    "label": "Greenland",
    "value": "Greenland"
  },
  {
    "label": "Grown Alchemist",
    "value": "Grown Alchemist"
  },
  {
    "label": "Gucci",
    "value": "Gucci"
  },
  {
    "label": "Guerlain",
    "value": "Guerlain"
  },
  {
    "label": "Guess",
    "value": "Guess"
  },
  {
    "label": "Guillaumond",
    "value": "Guillaumond"
  },
  {
    "label": "H&M",
    "value": "H&M"
  },
  {
    "label": "Hennes & Mauritz",
    "value": "Hennes & Mauritz"
  },
  {
    "label": "H",
    "value": "H"
  },
  {
    "label": "H.I.S Shop",
    "value": "H.I.S Shop"
  },
  {
    "label": "H.I.S",
    "value": "H.I.S"
  },
  {
    "label": "HALLHUBER",
    "value": "HALLHUBER"
  },
  {
    "label": "HASSIA",
    "value": "HASSIA"
  },
  {
    "label": "HAVAIANAS",
    "value": "HAVAIANAS"
  },
  {
    "label": "HELLY HANSEN",
    "value": "HELLY HANSEN"
  },
  {
    "label": "HERMÈS",
    "value": "HERMÈS"
  },
  {
    "label": "HEXAGON by Don Diablo",
    "value": "HEXAGON by Don Diablo"
  },
  {
    "label": "HI-TEC",
    "value": "HI-TEC"
  },
  {
    "label": "HOLDEReight",
    "value": "HOLDEReight"
  },
  {
    "label": "HOLLISTER",
    "value": "HOLLISTER"
  },
  {
    "label": "HOMEBASE",
    "value": "HOMEBASE"
  },
  {
    "label": "HOMEBOY BEACH",
    "value": "HOMEBOY BEACH"
  },
  {
    "label": "HUB",
    "value": "HUB"
  },
  {
    "label": "HUEZ",
    "value": "HUEZ"
  },
  {
    "label": "HUF",
    "value": "HUF"
  },
  {
    "label": "HUGO BOSS",
    "value": "HUGO BOSS"
  },
  {
    "label": "HUGO",
    "value": "HUGO"
  },
  {
    "label": "HUNTER",
    "value": "HUNTER"
  },
  {
    "label": "HXTN Supply",
    "value": "HXTN Supply"
  },
  {
    "label": "Haglöfs",
    "value": "Haglöfs"
  },
  {
    "label": "Haikure",
    "value": "Haikure"
  },
  {
    "label": "Hailys",
    "value": "Hailys"
  },
  {
    "label": "Halston Heritage",
    "value": "Halston Heritage"
  },
  {
    "label": "Halti",
    "value": "Halti"
  },
  {
    "label": "Hamilton",
    "value": "Hamilton"
  },
  {
    "label": "Hammam34",
    "value": "Hammam34"
  },
  {
    "label": "Han Kjobenhavn",
    "value": "Han Kjobenhavn"
  },
  {
    "label": "Hanro",
    "value": "Hanro"
  },
  {
    "label": "Happy Plugs",
    "value": "Happy Plugs"
  },
  {
    "label": "Happy Socks",
    "value": "Happy Socks"
  },
  {
    "label": "Hardware",
    "value": "Hardware"
  },
  {
    "label": "Harman Kardon",
    "value": "Harman Kardon"
  },
  {
    "label": "Harmony",
    "value": "Harmony"
  },
  {
    "label": "Havaianas",
    "value": "Havaianas"
  },
  {
    "label": "Hay",
    "value": "Hay"
  },
  {
    "label": "Head Over Heels",
    "value": "Head Over Heels"
  },
  {
    "label": "Head",
    "value": "Head"
  },
  {
    "label": "Heart to get",
    "value": "Heart to get"
  },
  {
    "label": "Heidi Klein",
    "value": "Heidi Klein"
  },
  {
    "label": "Heidi Klum Intimates",
    "value": "Heidi Klum Intimates"
  },
  {
    "label": "Heidi Klum",
    "value": "Heidi Klum"
  },
  {
    "label": "Helen Moore",
    "value": "Helen Moore"
  },
  {
    "label": "Helia",
    "value": "Helia"
  },
  {
    "label": "Hellen van Berkel",
    "value": "Hellen van Berkel"
  },
  {
    "label": "Helly Hansen",
    "value": "Helly Hansen"
  },
  {
    "label": "Helmut Lang",
    "value": "Helmut Lang"
  },
  {
    "label": "Henry London",
    "value": "Henry London"
  },
  {
    "label": "Heron Preston",
    "value": "Heron Preston"
  },
  {
    "label": "Herrlicher",
    "value": "Herrlicher"
  },
  {
    "label": "Herschel Supply",
    "value": "Herschel Supply"
  },
  {
    "label": "Herschel",
    "value": "Herschel"
  },
  {
    "label": "Hesper Fox",
    "value": "Hesper Fox"
  },
  {
    "label": "Hestra",
    "value": "Hestra"
  },
  {
    "label": "Hey Honey",
    "value": "Hey Honey"
  },
  {
    "label": "Hi-Tec",
    "value": "Hi-Tec"
  },
  {
    "label": "Hilfiger Denim",
    "value": "Hilfiger Denim"
  },
  {
    "label": "Hirsch",
    "value": "Hirsch"
  },
  {
    "label": "Hobbs",
    "value": "Hobbs"
  },
  {
    "label": "Hogan",
    "value": "Hogan"
  },
  {
    "label": "Hollister Co.",
    "value": "Hollister Co."
  },
  {
    "label": "Holzweiler",
    "value": "Holzweiler"
  },
  {
    "label": "Homebase",
    "value": "Homebase"
  },
  {
    "label": "Homeboy",
    "value": "Homeboy"
  },
  {
    "label": "Homers",
    "value": "Homers"
  },
  {
    "label": "Honey Punch",
    "value": "Honey Punch"
  },
  {
    "label": "Hoodlamb",
    "value": "Hoodlamb"
  },
  {
    "label": "Hope & Ivy",
    "value": "Hope & Ivy"
  },
  {
    "label": "Hope",
    "value": "Hope"
  },
  {
    "label": "Horsefeathers",
    "value": "Horsefeathers"
  },
  {
    "label": "Hoss Intropia",
    "value": "Hoss Intropia"
  },
  {
    "label": "Hot Soles",
    "value": "Hot Soles"
  },
  {
    "label": "Hot as Hell",
    "value": "Hot as Hell"
  },
  {
    "label": "House in Style",
    "value": "House in Style"
  },
  {
    "label": "House of Dagmar",
    "value": "House of Dagmar"
  },
  {
    "label": "House of Holland",
    "value": "House of Holland"
  },
  {
    "label": "House of Sunny",
    "value": "House of Sunny"
  },
  {
    "label": "Hudson",
    "value": "Hudson"
  },
  {
    "label": "Hugo Boss Shop",
    "value": "Hugo Boss Shop"
  },
  {
    "label": "Humanoid",
    "value": "Humanoid"
  },
  {
    "label": "Hummel Shop",
    "value": "Hummel Shop"
  },
  {
    "label": "Hummel",
    "value": "Hummel"
  },
  {
    "label": "Hundred 100",
    "value": "Hundred 100"
  },
  {
    "label": "Hunkemöller",
    "value": "Hunkemöller"
  },
  {
    "label": "Hunkydory",
    "value": "Hunkydory"
  },
  {
    "label": "Hunter",
    "value": "Hunter"
  },
  {
    "label": "Hydro Flask",
    "value": "Hydro Flask"
  },
  {
    "label": "Hype",
    "value": "Hype"
  },
  {
    "label": "Hysteria",
    "value": "Hysteria"
  },
  {
    "label": "Högl",
    "value": "Högl"
  },
  {
    "label": "I Love Mr Mittens",
    "value": "I Love Mr Mittens"
  },
  {
    "label": "I.scenery",
    "value": "I.scenery"
  },
  {
    "label": "ICEPEAK",
    "value": "ICEPEAK"
  },
  {
    "label": "ICHI",
    "value": "ICHI"
  },
  {
    "label": "ICON by Cyell",
    "value": "ICON by Cyell"
  },
  {
    "label": "ID Fine",
    "value": "ID Fine"
  },
  {
    "label": "IDIOT DU VILLAGE",
    "value": "IDIOT DU VILLAGE"
  },
  {
    "label": "IGI&CO",
    "value": "IGI&CO"
  },
  {
    "label": "IKKS Shop",
    "value": "IKKS Shop"
  },
  {
    "label": "IKKS",
    "value": "IKKS"
  },
  {
    "label": "ILSE JACOBSEN",
    "value": "ILSE JACOBSEN"
  },
  {
    "label": "INDICODE JEANS",
    "value": "INDICODE JEANS"
  },
  {
    "label": "INGLOT",
    "value": "INGLOT"
  },
  {
    "label": "INUIKII",
    "value": "INUIKII"
  },
  {
    "label": "INUOVO",
    "value": "INUOVO"
  },
  {
    "label": "ION",
    "value": "ION"
  },
  {
    "label": "IRO",
    "value": "IRO"
  },
  {
    "label": "ISABELLA OLIVER",
    "value": "ISABELLA OLIVER"
  },
  {
    "label": "IVY & OAK BRIDAL",
    "value": "IVY & OAK BRIDAL"
  },
  {
    "label": "IVY & OAK",
    "value": "IVY & OAK"
  },
  {
    "label": "IVY PARK",
    "value": "IVY PARK"
  },
  {
    "label": "IVYREVEL",
    "value": "IVYREVEL"
  },
  {
    "label": "IZIPIZI",
    "value": "IZIPIZI"
  },
  {
    "label": "Ibana",
    "value": "Ibana"
  },
  {
    "label": "Ice-Watch",
    "value": "Ice-Watch"
  },
  {
    "label": "Iceberg Shop",
    "value": "Iceberg Shop"
  },
  {
    "label": "Iceberg",
    "value": "Iceberg"
  },
  {
    "label": "Icebound",
    "value": "Icebound"
  },
  {
    "label": "Icebreaker",
    "value": "Icebreaker"
  },
  {
    "label": "Icepeak",
    "value": "Icepeak"
  },
  {
    "label": "Iden",
    "value": "Iden"
  },
  {
    "label": "Iheart",
    "value": "Iheart"
  },
  {
    "label": "Ilse Jacobsen",
    "value": "Ilse Jacobsen"
  },
  {
    "label": "Imagine Vince Camuto",
    "value": "Imagine Vince Camuto"
  },
  {
    "label": "Impliva",
    "value": "Impliva"
  },
  {
    "label": "InWear",
    "value": "InWear"
  },
  {
    "label": "Incase",
    "value": "Incase"
  },
  {
    "label": "Inferno Ragazzi",
    "value": "Inferno Ragazzi"
  },
  {
    "label": "Inov-8",
    "value": "Inov-8"
  },
  {
    "label": "Intentionally Blank",
    "value": "Intentionally Blank"
  },
  {
    "label": "Inuovo",
    "value": "Inuovo"
  },
  {
    "label": "Inyati",
    "value": "Inyati"
  },
  {
    "label": "Iodus",
    "value": "Iodus"
  },
  {
    "label": "Ipanema",
    "value": "Ipanema"
  },
  {
    "label": "Iphoria",
    "value": "Iphoria"
  },
  {
    "label": "Iriedaily",
    "value": "Iriedaily"
  },
  {
    "label": "Iro",
    "value": "Iro"
  },
  {
    "label": "Isabel Marant Étoile",
    "value": "Isabel Marant Étoile"
  },
  {
    "label": "Isabel Marant",
    "value": "Isabel Marant"
  },
  {
    "label": "Isla Ibiza Bonita",
    "value": "Isla Ibiza Bonita"
  },
  {
    "label": "Issey Miyake",
    "value": "Issey Miyake"
  },
  {
    "label": "Ivko",
    "value": "Ivko"
  },
  {
    "label": "Ivy & Oak Shop",
    "value": "Ivy & Oak Shop"
  },
  {
    "label": "Ivy Park",
    "value": "Ivy Park"
  },
  {
    "label": "Ivylee Copenhagen",
    "value": "Ivylee Copenhagen"
  },
  {
    "label": "Ivyrevel",
    "value": "Ivyrevel"
  },
  {
    "label": "J Brand",
    "value": "J Brand"
  },
  {
    "label": "J.CREW PETITE",
    "value": "J.CREW PETITE"
  },
  {
    "label": "J.CREW Shop",
    "value": "J.CREW Shop"
  },
  {
    "label": "J.CREW TALL",
    "value": "J.CREW TALL"
  },
  {
    "label": "J.Crew",
    "value": "J.Crew"
  },
  {
    "label": "J.LINDEBERG Shop",
    "value": "J.LINDEBERG Shop"
  },
  {
    "label": "J.Lindeberg",
    "value": "J.Lindeberg"
  },
  {
    "label": "J.O.A",
    "value": "J.O.A"
  },
  {
    "label": "JACK & JONES",
    "value": "JACK & JONES"
  },
  {
    "label": "JACK WOLFSKIN",
    "value": "JACK WOLFSKIN"
  },
  {
    "label": "JACQUELINE de YONG",
    "value": "JACQUELINE de YONG"
  },
  {
    "label": "JBL",
    "value": "JBL"
  },
  {
    "label": "JC Play",
    "value": "JC Play"
  },
  {
    "label": "JDY",
    "value": "JDY"
  },
  {
    "label": "JETS BY JESSIKA ALLEN",
    "value": "JETS BY JESSIKA ALLEN"
  },
  {
    "label": "JETTE",
    "value": "JETTE"
  },
  {
    "label": "JOOP!",
    "value": "JOOP!"
  },
  {
    "label": "JOST",
    "value": "JOST"
  },
  {
    "label": "JUST FEMALE",
    "value": "JUST FEMALE"
  },
  {
    "label": "Jack Wolfskin",
    "value": "Jack Wolfskin"
  },
  {
    "label": "Jaded London",
    "value": "Jaded London"
  },
  {
    "label": "Jakke",
    "value": "Jakke"
  },
  {
    "label": "James Perse",
    "value": "James Perse"
  },
  {
    "label": "James Read Tan",
    "value": "James Read Tan"
  },
  {
    "label": "Jana",
    "value": "Jana"
  },
  {
    "label": "Jane Kønig",
    "value": "Jane Kønig"
  },
  {
    "label": "Janet & Janet Shop",
    "value": "Janet & Janet Shop"
  },
  {
    "label": "Janet & Janet",
    "value": "Janet & Janet"
  },
  {
    "label": "Janet Sport",
    "value": "Janet Sport"
  },
  {
    "label": "JapanTKY",
    "value": "JapanTKY"
  },
  {
    "label": "Jarlo",
    "value": "Jarlo"
  },
  {
    "label": "Jason Markk",
    "value": "Jason Markk"
  },
  {
    "label": "Jean Paul Gaultier",
    "value": "Jean Paul Gaultier"
  },
  {
    "label": "Jeepers Peepers",
    "value": "Jeepers Peepers"
  },
  {
    "label": "Jeffery West",
    "value": "Jeffery West"
  },
  {
    "label": "Jeffrey Campbell",
    "value": "Jeffrey Campbell"
  },
  {
    "label": "Jenny",
    "value": "Jenny"
  },
  {
    "label": "Jennyfer",
    "value": "Jennyfer"
  },
  {
    "label": "Jerome Dreyfuss",
    "value": "Jerome Dreyfuss"
  },
  {
    "label": "Jessica Simpson",
    "value": "Jessica Simpson"
  },
  {
    "label": "Jigsaw",
    "value": "Jigsaw"
  },
  {
    "label": "Jil Sander Navy",
    "value": "Jil Sander Navy"
  },
  {
    "label": "Jil Sander",
    "value": "Jil Sander"
  },
  {
    "label": "Jimmy Choo",
    "value": "Jimmy Choo"
  },
  {
    "label": "Jimmy Lion",
    "value": "Jimmy Lion"
  },
  {
    "label": "Jo Malone London",
    "value": "Jo Malone London"
  },
  {
    "label": "JoJo Maman Bébé",
    "value": "JoJo Maman Bébé"
  },
  {
    "label": "Johnstons Cashmere",
    "value": "Johnstons Cashmere"
  },
  {
    "label": "Johnstons of Elgin",
    "value": "Johnstons of Elgin"
  },
  {
    "label": "Jonak",
    "value": "Jonak"
  },
  {
    "label": "Joop! Accessories",
    "value": "Joop! Accessories"
  },
  {
    "label": "Joop! Shop",
    "value": "Joop! Shop"
  },
  {
    "label": "Jordan",
    "value": "Jordan"
  },
  {
    "label": "Joseph",
    "value": "Joseph"
  },
  {
    "label": "Josephine & Co Red Label",
    "value": "Josephine & Co Red Label"
  },
  {
    "label": "Josephine & Co",
    "value": "Josephine & Co"
  },
  {
    "label": "Joshua Sanders",
    "value": "Joshua Sanders"
  },
  {
    "label": "Jost",
    "value": "Jost"
  },
  {
    "label": "José Eber",
    "value": "José Eber"
  },
  {
    "label": "Juicy Couture Black Label",
    "value": "Juicy Couture Black Label"
  },
  {
    "label": "Juicy Couture Plus",
    "value": "Juicy Couture Plus"
  },
  {
    "label": "Juicy Couture",
    "value": "Juicy Couture"
  },
  {
    "label": "Juicy by Juicy Couture",
    "value": "Juicy by Juicy Couture"
  },
  {
    "label": "Julia June",
    "value": "Julia June"
  },
  {
    "label": "Julie Sandlau",
    "value": "Julie Sandlau"
  },
  {
    "label": "Juliet Dunn",
    "value": "Juliet Dunn"
  },
  {
    "label": "Juliette has a gun",
    "value": "Juliette has a gun"
  },
  {
    "label": "Junarose",
    "value": "Junarose"
  },
  {
    "label": "Junghans",
    "value": "Junghans"
  },
  {
    "label": "Jusbox",
    "value": "Jusbox"
  },
  {
    "label": "Just Cavalli",
    "value": "Just Cavalli"
  },
  {
    "label": "Just Rhyse",
    "value": "Just Rhyse"
  },
  {
    "label": "Just in Case",
    "value": "Just in Case"
  },
  {
    "label": "Juvia",
    "value": "Juvia"
  },
  {
    "label": "Jérôme Dreyfuss",
    "value": "Jérôme Dreyfuss"
  },
  {
    "label": "K-SWISS",
    "value": "K-SWISS"
  },
  {
    "label": "K-Way",
    "value": "K-Way"
  },
  {
    "label": "K. Jacques St. Tropez",
    "value": "K. Jacques St. Tropez"
  },
  {
    "label": "K1X",
    "value": "K1X"
  },
  {
    "label": "KAPPA",
    "value": "KAPPA"
  },
  {
    "label": "KARL LAGERFELD",
    "value": "KARL LAGERFELD"
  },
  {
    "label": "KCA-LAB",
    "value": "KCA-LAB"
  },
  {
    "label": "KEEN",
    "value": "KEEN"
  },
  {
    "label": "KENDALL + KYLIE",
    "value": "KENDALL + KYLIE"
  },
  {
    "label": "KENZO",
    "value": "KENZO"
  },
  {
    "label": "KG by Kurt Geiger",
    "value": "KG by Kurt Geiger"
  },
  {
    "label": "KICKERS",
    "value": "KICKERS"
  },
  {
    "label": "KILLTEC",
    "value": "KILLTEC"
  },
  {
    "label": "KIOMI Shop",
    "value": "KIOMI Shop"
  },
  {
    "label": "KIOMI TALL",
    "value": "KIOMI TALL"
  },
  {
    "label": "KIOMI",
    "value": "KIOMI"
  },
  {
    "label": "KMB",
    "value": "KMB"
  },
  {
    "label": "KOH",
    "value": "KOH"
  },
  {
    "label": "KUNERT",
    "value": "KUNERT"
  },
  {
    "label": "Kaffe",
    "value": "Kaffe"
  },
  {
    "label": "Kamik",
    "value": "Kamik"
  },
  {
    "label": "KangaROOS",
    "value": "KangaROOS"
  },
  {
    "label": "Kangol",
    "value": "Kangol"
  },
  {
    "label": "Kanna",
    "value": "Kanna"
  },
  {
    "label": "Kaporal",
    "value": "Kaporal"
  },
  {
    "label": "Kappa Shop",
    "value": "Kappa Shop"
  },
  {
    "label": "Kappa",
    "value": "Kappa"
  },
  {
    "label": "Kapten & Son",
    "value": "Kapten & Son"
  },
  {
    "label": "Karen Millen",
    "value": "Karen Millen"
  },
  {
    "label": "Karen by Simonsen",
    "value": "Karen by Simonsen"
  },
  {
    "label": "KariTraa",
    "value": "KariTraa"
  },
  {
    "label": "Karl Kani",
    "value": "Karl Kani"
  },
  {
    "label": "Karl Lagerfeld",
    "value": "Karl Lagerfeld"
  },
  {
    "label": "Kat Maconie",
    "value": "Kat Maconie"
  },
  {
    "label": "Katy Perry",
    "value": "Katy Perry"
  },
  {
    "label": "Kayu",
    "value": "Kayu"
  },
  {
    "label": "Keds",
    "value": "Keds"
  },
  {
    "label": "Keen",
    "value": "Keen"
  },
  {
    "label": "Keepsake",
    "value": "Keepsake"
  },
  {
    "label": "Kempa",
    "value": "Kempa"
  },
  {
    "label": "Kengstar",
    "value": "Kengstar"
  },
  {
    "label": "Kennel + Schmenger",
    "value": "Kennel + Schmenger"
  },
  {
    "label": "Kenneth Cole New York",
    "value": "Kenneth Cole New York"
  },
  {
    "label": "Kenneth Cole Shop",
    "value": "Kenneth Cole Shop"
  },
  {
    "label": "Kenneth Jay Lane",
    "value": "Kenneth Jay Lane"
  },
  {
    "label": "Kentucky's Western",
    "value": "Kentucky's Western"
  },
  {
    "label": "Kenzo Shop",
    "value": "Kenzo Shop"
  },
  {
    "label": "Kenzo",
    "value": "Kenzo"
  },
  {
    "label": "Kerbholz",
    "value": "Kerbholz"
  },
  {
    "label": "Key Largo",
    "value": "Key Largo"
  },
  {
    "label": "Key West",
    "value": "Key West"
  },
  {
    "label": "Kickers",
    "value": "Kickers"
  },
  {
    "label": "Kiehl's",
    "value": "Kiehl's"
  },
  {
    "label": "Kikkerland",
    "value": "Kikkerland"
  },
  {
    "label": "Kilian",
    "value": "Kilian"
  },
  {
    "label": "Killtec",
    "value": "Killtec"
  },
  {
    "label": "King Louie",
    "value": "King Louie"
  },
  {
    "label": "Kings Of Indigo",
    "value": "Kings Of Indigo"
  },
  {
    "label": "Kio",
    "value": "Kio"
  },
  {
    "label": "Kipling",
    "value": "Kipling"
  },
  {
    "label": "Kiro by Kim",
    "value": "Kiro by Kim"
  },
  {
    "label": "Kiwi Saint Tropez",
    "value": "Kiwi Saint Tropez"
  },
  {
    "label": "Kjaer Copenhagen",
    "value": "Kjaer Copenhagen"
  },
  {
    "label": "Kjus",
    "value": "Kjus"
  },
  {
    "label": "Klean Kanteen",
    "value": "Klean Kanteen"
  },
  {
    "label": "Klevering &K",
    "value": "Klevering &K"
  },
  {
    "label": "Komono",
    "value": "Komono"
  },
  {
    "label": "Konplott",
    "value": "Konplott"
  },
  {
    "label": "Kookai",
    "value": "Kookai"
  },
  {
    "label": "Korres",
    "value": "Korres"
  },
  {
    "label": "Kreafunk",
    "value": "Kreafunk"
  },
  {
    "label": "Krüger Dirndl",
    "value": "Krüger Dirndl"
  },
  {
    "label": "Krüger Madl",
    "value": "Krüger Madl"
  },
  {
    "label": "Ksenia Schnaider",
    "value": "Ksenia Schnaider"
  },
  {
    "label": "Kunert",
    "value": "Kunert"
  },
  {
    "label": "Kurt Geiger Shop",
    "value": "Kurt Geiger Shop"
  },
  {
    "label": "Kurt Geiger",
    "value": "Kurt Geiger"
  },
  {
    "label": "Kyra & Ko",
    "value": "Kyra & Ko"
  },
  {
    "label": "L'Agent by Agent Provocateur",
    "value": "L'Agent by Agent Provocateur"
  },
  {
    "label": "L'Autre Chose",
    "value": "L'Autre Chose"
  },
  {
    "label": "L'INTERVALLE",
    "value": "L'INTERVALLE"
  },
  {
    "label": "L*Space",
    "value": "L*Space"
  },
  {
    "label": "L.Credi",
    "value": "L.Credi"
  },
  {
    "label": "L.K.Bennett",
    "value": "L.K.Bennett"
  },
  {
    "label": "L37",
    "value": "L37"
  },
  {
    "label": "LAB",
    "value": "LAB"
  },
  {
    "label": "LACOSTE",
    "value": "LACOSTE"
  },
  {
    "label": "LANCASTER",
    "value": "LANCASTER"
  },
  {
    "label": "LASCANA",
    "value": "LASCANA"
  },
  {
    "label": "LAURA SCOTT",
    "value": "LAURA SCOTT"
  },
  {
    "label": "LAURA VITA",
    "value": "LAURA VITA"
  },
  {
    "label": "LAUREL",
    "value": "LAUREL"
  },
  {
    "label": "LE SPECS",
    "value": "LE SPECS"
  },
  {
    "label": "LEGEND",
    "value": "LEGEND"
  },
  {
    "label": "LELET NY",
    "value": "LELET NY"
  },
  {
    "label": "LEMON JELLY",
    "value": "LEMON JELLY"
  },
  {
    "label": "LEVI'S",
    "value": "LEVI'S"
  },
  {
    "label": "LEXI",
    "value": "LEXI"
  },
  {
    "label": "LEÏ 1984",
    "value": "LEÏ 1984"
  },
  {
    "label": "LIARS & LOVERS",
    "value": "LIARS & LOVERS"
  },
  {
    "label": "LIEBLINGSSTÜCK",
    "value": "LIEBLINGSSTÜCK"
  },
  {
    "label": "LIU JO Shop",
    "value": "LIU JO Shop"
  },
  {
    "label": "LIU JO",
    "value": "LIU JO"
  },
  {
    "label": "LK Bennett",
    "value": "LK Bennett"
  },
  {
    "label": "LNDR",
    "value": "LNDR"
  },
  {
    "label": "LOIS Jeans",
    "value": "LOIS Jeans"
  },
  {
    "label": "LOTT. gioielli",
    "value": "LOTT. gioielli"
  },
  {
    "label": "LOVE Stories",
    "value": "LOVE Stories"
  },
  {
    "label": "LOVE2WAIT",
    "value": "LOVE2WAIT"
  },
  {
    "label": "LOWE ALPINE",
    "value": "LOWE ALPINE"
  },
  {
    "label": "LTB – Love To Be",
    "value": "LTB – Love To Be"
  },
  {
    "label": "LTB",
    "value": "LTB"
  },
  {
    "label": "LUHTA",
    "value": "LUHTA"
  },
  {
    "label": "LYDC London",
    "value": "LYDC London"
  },
  {
    "label": "La Collerette",
    "value": "La Collerette"
  },
  {
    "label": "La Fee Maraboutee",
    "value": "La Fee Maraboutee"
  },
  {
    "label": "La Mer",
    "value": "La Mer"
  },
  {
    "label": "La Perla",
    "value": "La Perla"
  },
  {
    "label": "La Petite Française",
    "value": "La Petite Française"
  },
  {
    "label": "La Sportiva",
    "value": "La Sportiva"
  },
  {
    "label": "LaDress",
    "value": "LaDress"
  },
  {
    "label": "LaSalle",
    "value": "LaSalle"
  },
  {
    "label": "Lace & Beads Curvy",
    "value": "Lace & Beads Curvy"
  },
  {
    "label": "Lace & Beads Petite",
    "value": "Lace & Beads Petite"
  },
  {
    "label": "Lace & Beads Tall",
    "value": "Lace & Beads Tall"
  },
  {
    "label": "Lace & Beads",
    "value": "Lace & Beads"
  },
  {
    "label": "Lacoste LIVE",
    "value": "Lacoste LIVE"
  },
  {
    "label": "Lacoste Shop",
    "value": "Lacoste Shop"
  },
  {
    "label": "Lacoste Sport",
    "value": "Lacoste Sport"
  },
  {
    "label": "Lacoste",
    "value": "Lacoste"
  },
  {
    "label": "Lafuma",
    "value": "Lafuma"
  },
  {
    "label": "Lakeville Mountain",
    "value": "Lakeville Mountain"
  },
  {
    "label": "Lalique",
    "value": "Lalique"
  },
  {
    "label": "Lamica",
    "value": "Lamica"
  },
  {
    "label": "Lancaster",
    "value": "Lancaster"
  },
  {
    "label": "Lancel",
    "value": "Lancel"
  },
  {
    "label": "Lancôme",
    "value": "Lancôme"
  },
  {
    "label": "Lanvin",
    "value": "Lanvin"
  },
  {
    "label": "Laona",
    "value": "Laona"
  },
  {
    "label": "Larsson & Jennings",
    "value": "Larsson & Jennings"
  },
  {
    "label": "Laura Bellariva",
    "value": "Laura Bellariva"
  },
  {
    "label": "Laura Biagiotti",
    "value": "Laura Biagiotti"
  },
  {
    "label": "Laura Mercier",
    "value": "Laura Mercier"
  },
  {
    "label": "Lavish Alice",
    "value": "Lavish Alice"
  },
  {
    "label": "Lazamani",
    "value": "Lazamani"
  },
  {
    "label": "Le Cord",
    "value": "Le Cord"
  },
  {
    "label": "Le Labo",
    "value": "Le Labo"
  },
  {
    "label": "Le Petit Trou",
    "value": "Le Petit Trou"
  },
  {
    "label": "Le Specs",
    "value": "Le Specs"
  },
  {
    "label": "Le Tanneur",
    "value": "Le Tanneur"
  },
  {
    "label": "Le Temps Des Cerises Shop",
    "value": "Le Temps Des Cerises Shop"
  },
  {
    "label": "Le Temps Des Cerises",
    "value": "Le Temps Des Cerises"
  },
  {
    "label": "LeGer by Lena Gercke",
    "value": "LeGer by Lena Gercke"
  },
  {
    "label": "Leandro Lopes",
    "value": "Leandro Lopes"
  },
  {
    "label": "Lebon",
    "value": "Lebon"
  },
  {
    "label": "Lee Shop",
    "value": "Lee Shop"
  },
  {
    "label": "Lee",
    "value": "Lee"
  },
  {
    "label": "Legend",
    "value": "Legend"
  },
  {
    "label": "Legero",
    "value": "Legero"
  },
  {
    "label": "Lemargo",
    "value": "Lemargo"
  },
  {
    "label": "Lena Gercke x About You",
    "value": "Lena Gercke x About You"
  },
  {
    "label": "Leon & Harper",
    "value": "Leon & Harper"
  },
  {
    "label": "Leon and Harper",
    "value": "Leon and Harper"
  },
  {
    "label": "Leonhard Heyden",
    "value": "Leonhard Heyden"
  },
  {
    "label": "Les Cleias",
    "value": "Les Cleias"
  },
  {
    "label": "Les Girls Les Boys",
    "value": "Les Girls Les Boys"
  },
  {
    "label": "Les Petites...",
    "value": "Les Petites..."
  },
  {
    "label": "Les Tropéziennes par M Belarbi",
    "value": "Les Tropéziennes par M Belarbi"
  },
  {
    "label": "Levete Room",
    "value": "Levete Room"
  },
  {
    "label": "Levi's Made & Crafted",
    "value": "Levi's Made & Crafted"
  },
  {
    "label": "Levi's",
    "value": "Levi's"
  },
  {
    "label": "Levi's® Line 8",
    "value": "Levi's® Line 8"
  },
  {
    "label": "Levi's® Made & Crafted",
    "value": "Levi's® Made & Crafted"
  },
  {
    "label": "Levi's® Plus",
    "value": "Levi's® Plus"
  },
  {
    "label": "Levi's® Shop",
    "value": "Levi's® Shop"
  },
  {
    "label": "Levi's®",
    "value": "Levi's®"
  },
  {
    "label": "Levi’s Line 8",
    "value": "Levi’s Line 8"
  },
  {
    "label": "Lez a Lez",
    "value": "Lez a Lez"
  },
  {
    "label": "Libertine Libertine",
    "value": "Libertine Libertine"
  },
  {
    "label": "Libertine-Libertine",
    "value": "Libertine-Libertine"
  },
  {
    "label": "Liebesglück",
    "value": "Liebesglück"
  },
  {
    "label": "Liebeskind Berlin",
    "value": "Liebeskind Berlin"
  },
  {
    "label": "Liebeskind Shop",
    "value": "Liebeskind Shop"
  },
  {
    "label": "Liebeskind",
    "value": "Liebeskind"
  },
  {
    "label": "Lilliput & Felix",
    "value": "Lilliput & Felix"
  },
  {
    "label": "Limited Sports",
    "value": "Limited Sports"
  },
  {
    "label": "Linari",
    "value": "Linari"
  },
  {
    "label": "LingaDore",
    "value": "LingaDore"
  },
  {
    "label": "Lipstick boutique",
    "value": "Lipstick boutique"
  },
  {
    "label": "Lipsy Petite",
    "value": "Lipsy Petite"
  },
  {
    "label": "Lipsy Shop",
    "value": "Lipsy Shop"
  },
  {
    "label": "Lipsy",
    "value": "Lipsy"
  },
  {
    "label": "Liquor N Poker Curve",
    "value": "Liquor N Poker Curve"
  },
  {
    "label": "Liquor N Poker Tall",
    "value": "Liquor N Poker Tall"
  },
  {
    "label": "Liquor N Poker",
    "value": "Liquor N Poker"
  },
  {
    "label": "Little Mistress Curvy",
    "value": "Little Mistress Curvy"
  },
  {
    "label": "Little Mistress Petite",
    "value": "Little Mistress Petite"
  },
  {
    "label": "Little Mistress Shop",
    "value": "Little Mistress Shop"
  },
  {
    "label": "Little Mistress",
    "value": "Little Mistress"
  },
  {
    "label": "Little White Lies",
    "value": "Little White Lies"
  },
  {
    "label": "Liu Jo Jeans",
    "value": "Liu Jo Jeans"
  },
  {
    "label": "Liu Jo",
    "value": "Liu Jo"
  },
  {
    "label": "Live Unlimited London",
    "value": "Live Unlimited London"
  },
  {
    "label": "Livia",
    "value": "Livia"
  },
  {
    "label": "Living Kitzbühel",
    "value": "Living Kitzbühel"
  },
  {
    "label": "Lodi",
    "value": "Lodi"
  },
  {
    "label": "Loeffler Randall",
    "value": "Loeffler Randall"
  },
  {
    "label": "Loewe",
    "value": "Loewe"
  },
  {
    "label": "Lois",
    "value": "Lois"
  },
  {
    "label": "Lola Cruz",
    "value": "Lola Cruz"
  },
  {
    "label": "Lollys Laundry",
    "value": "Lollys Laundry"
  },
  {
    "label": "Lolë",
    "value": "Lolë"
  },
  {
    "label": "Longchamp",
    "value": "Longchamp"
  },
  {
    "label": "Loreak",
    "value": "Loreak"
  },
  {
    "label": "Lorna Jane",
    "value": "Lorna Jane"
  },
  {
    "label": "Lost Ink Petite",
    "value": "Lost Ink Petite"
  },
  {
    "label": "Lost Ink Plus",
    "value": "Lost Ink Plus"
  },
  {
    "label": "Lost Ink Shop",
    "value": "Lost Ink Shop"
  },
  {
    "label": "Lost Ink Wide Fit",
    "value": "Lost Ink Wide Fit"
  },
  {
    "label": "Lost Ink",
    "value": "Lost Ink"
  },
  {
    "label": "Lotto",
    "value": "Lotto"
  },
  {
    "label": "Louche",
    "value": "Louche"
  },
  {
    "label": "Loungeable",
    "value": "Loungeable"
  },
  {
    "label": "Lova & Rosie",
    "value": "Lova & Rosie"
  },
  {
    "label": "Love & Divine",
    "value": "Love & Divine"
  },
  {
    "label": "Love Moschino",
    "value": "Love Moschino"
  },
  {
    "label": "Love Stories",
    "value": "Love Stories"
  },
  {
    "label": "Love Triangle",
    "value": "Love Triangle"
  },
  {
    "label": "Lovechild",
    "value": "Lovechild"
  },
  {
    "label": "Lowa",
    "value": "Lowa"
  },
  {
    "label": "Luca Grossi",
    "value": "Luca Grossi"
  },
  {
    "label": "Luhta",
    "value": "Luhta"
  },
  {
    "label": "Luisa Cerano",
    "value": "Luisa Cerano"
  },
  {
    "label": "Luli Fama",
    "value": "Luli Fama"
  },
  {
    "label": "Lulu Guinness",
    "value": "Lulu Guinness"
  },
  {
    "label": "Lundhags",
    "value": "Lundhags"
  },
  {
    "label": "Luxuar Fashion",
    "value": "Luxuar Fashion"
  },
  {
    "label": "LÖFFLER",
    "value": "LÖFFLER"
  },
  {
    "label": "Lässig",
    "value": "Lässig"
  },
  {
    "label": "L’Autre Chose",
    "value": "L’Autre Chose"
  },
  {
    "label": "M Missoni",
    "value": "M Missoni"
  },
  {
    "label": "MA&LO",
    "value": "MA&LO"
  },
  {
    "label": "MAC",
    "value": "MAC"
  },
  {
    "label": "MACARENA",
    "value": "MACARENA"
  },
  {
    "label": "MAERZ München",
    "value": "MAERZ München"
  },
  {
    "label": "MAGIC Bodyfashion",
    "value": "MAGIC Bodyfashion"
  },
  {
    "label": "MAI PIÙ SENZA",
    "value": "MAI PIÙ SENZA"
  },
  {
    "label": "MALAIKARAISS",
    "value": "MALAIKARAISS"
  },
  {
    "label": "MALIN+GOETZ",
    "value": "MALIN+GOETZ"
  },
  {
    "label": "MAMALICIOUS",
    "value": "MAMALICIOUS"
  },
  {
    "label": "MAMMUT",
    "value": "MAMMUT"
  },
  {
    "label": "MANGO",
    "value": "MANGO"
  },
  {
    "label": "MARCIANO LOS ANGELES",
    "value": "MARCIANO LOS ANGELES"
  },
  {
    "label": "MARIAMARE",
    "value": "MARIAMARE"
  },
  {
    "label": "MARIE CLAIRE",
    "value": "MARIE CLAIRE"
  },
  {
    "label": "MARJO",
    "value": "MARJO"
  },
  {
    "label": "MARUTI",
    "value": "MARUTI"
  },
  {
    "label": "MAX&Co.",
    "value": "MAX&Co."
  },
  {
    "label": "MELVIN & HAMILTON",
    "value": "MELVIN & HAMILTON"
  },
  {
    "label": "MET Helmets",
    "value": "MET Helmets"
  },
  {
    "label": "MEXX",
    "value": "MEXX"
  },
  {
    "label": "MICHAEL Michael Kors",
    "value": "MICHAEL Michael Kors"
  },
  {
    "label": "MICHALSKY FOR ABOUT YOU",
    "value": "MICHALSKY FOR ABOUT YOU"
  },
  {
    "label": "MIISTA",
    "value": "MIISTA"
  },
  {
    "label": "MINKPINK",
    "value": "MINKPINK"
  },
  {
    "label": "MIZU",
    "value": "MIZU"
  },
  {
    "label": "MJUS",
    "value": "MJUS"
  },
  {
    "label": "MKBM",
    "value": "MKBM"
  },
  {
    "label": "MKT Studio",
    "value": "MKT Studio"
  },
  {
    "label": "MO",
    "value": "MO"
  },
  {
    "label": "MOA - Master of Arts",
    "value": "MOA - Master of Arts"
  },
  {
    "label": "MOAM collective international",
    "value": "MOAM collective international"
  },
  {
    "label": "MONDKINI",
    "value": "MONDKINI"
  },
  {
    "label": "MOON BOOT",
    "value": "MOON BOOT"
  },
  {
    "label": "MORE & MORE",
    "value": "MORE & MORE"
  },
  {
    "label": "MOROTAI",
    "value": "MOROTAI"
  },
  {
    "label": "MOS MOSH",
    "value": "MOS MOSH"
  },
  {
    "label": "MOSCHINO SWIM",
    "value": "MOSCHINO SWIM"
  },
  {
    "label": "MOSCHINO Shop",
    "value": "MOSCHINO Shop"
  },
  {
    "label": "MOSS COPENHAGEN",
    "value": "MOSS COPENHAGEN"
  },
  {
    "label": "MR.BOHO",
    "value": "MR.BOHO"
  },
  {
    "label": "MRZ",
    "value": "MRZ"
  },
  {
    "label": "MSGM",
    "value": "MSGM"
  },
  {
    "label": "MTNG",
    "value": "MTNG"
  },
  {
    "label": "MUSTANG",
    "value": "MUSTANG"
  },
  {
    "label": "MYKKE HOFMANN",
    "value": "MYKKE HOFMANN"
  },
  {
    "label": "MYMO",
    "value": "MYMO"
  },
  {
    "label": "MYOMY",
    "value": "MYOMY"
  },
  {
    "label": "Maaji",
    "value": "Maaji"
  },
  {
    "label": "Mackintosh",
    "value": "Mackintosh"
  },
  {
    "label": "Madden Girl",
    "value": "Madden Girl"
  },
  {
    "label": "Madderson",
    "value": "Madderson"
  },
  {
    "label": "Madewell",
    "value": "Madewell"
  },
  {
    "label": "Mads Norgaard",
    "value": "Mads Norgaard"
  },
  {
    "label": "Mads Nørgaard",
    "value": "Mads Nørgaard"
  },
  {
    "label": "Mae & Ivy",
    "value": "Mae & Ivy"
  },
  {
    "label": "Magali Pascal",
    "value": "Magali Pascal"
  },
  {
    "label": "Magdalena",
    "value": "Magdalena"
  },
  {
    "label": "Magic Bodyfashion",
    "value": "Magic Bodyfashion"
  },
  {
    "label": "Magic Nights",
    "value": "Magic Nights"
  },
  {
    "label": "Maharishi",
    "value": "Maharishi"
  },
  {
    "label": "Maidenform",
    "value": "Maidenform"
  },
  {
    "label": "Maier Sports",
    "value": "Maier Sports"
  },
  {
    "label": "Maison Baluchon",
    "value": "Maison Baluchon"
  },
  {
    "label": "Maison Lejaby",
    "value": "Maison Lejaby"
  },
  {
    "label": "Maison Martin Margiela",
    "value": "Maison Martin Margiela"
  },
  {
    "label": "Maison Scotch",
    "value": "Maison Scotch"
  },
  {
    "label": "Maium Rainwear",
    "value": "Maium Rainwear"
  },
  {
    "label": "Maje",
    "value": "Maje"
  },
  {
    "label": "Majestic Filatures",
    "value": "Majestic Filatures"
  },
  {
    "label": "Maliparmi",
    "value": "Maliparmi"
  },
  {
    "label": "Maloja",
    "value": "Maloja"
  },
  {
    "label": "Mammut",
    "value": "Mammut"
  },
  {
    "label": "Mandarina Duck",
    "value": "Mandarina Duck"
  },
  {
    "label": "Manduka",
    "value": "Manduka"
  },
  {
    "label": "Mango Shop",
    "value": "Mango Shop"
  },
  {
    "label": "Mango",
    "value": "Mango"
  },
  {
    "label": "Manhattan Portage",
    "value": "Manhattan Portage"
  },
  {
    "label": "Manos del Uruguay",
    "value": "Manos del Uruguay"
  },
  {
    "label": "Mara Hoffman",
    "value": "Mara Hoffman"
  },
  {
    "label": "Marc Aurel",
    "value": "Marc Aurel"
  },
  {
    "label": "Marc Jacobs Shop",
    "value": "Marc Jacobs Shop"
  },
  {
    "label": "Marc Jacobs",
    "value": "Marc Jacobs"
  },
  {
    "label": "Marc O'Polo DENIM",
    "value": "Marc O'Polo DENIM"
  },
  {
    "label": "Marc O'Polo Shop",
    "value": "Marc O'Polo Shop"
  },
  {
    "label": "Marc O'Polo",
    "value": "Marc O'Polo"
  },
  {
    "label": "Marcel Ostertag x Tamaris",
    "value": "Marcel Ostertag x Tamaris"
  },
  {
    "label": "March",
    "value": "March"
  },
  {
    "label": "March23",
    "value": "March23"
  },
  {
    "label": "Marco Tozzi",
    "value": "Marco Tozzi"
  },
  {
    "label": "Marella",
    "value": "Marella"
  },
  {
    "label": "Maria Black",
    "value": "Maria Black"
  },
  {
    "label": "Maria Höfl-Riesch",
    "value": "Maria Höfl-Riesch"
  },
  {
    "label": "Maria Mare",
    "value": "Maria Mare"
  },
  {
    "label": "Marie Jo L'Aventure",
    "value": "Marie Jo L'Aventure"
  },
  {
    "label": "Marie Jo",
    "value": "Marie Jo"
  },
  {
    "label": "Marie Sixtine",
    "value": "Marie Sixtine"
  },
  {
    "label": "Marie-Stella-Maris",
    "value": "Marie-Stella-Maris"
  },
  {
    "label": "Marika",
    "value": "Marika"
  },
  {
    "label": "Marina Rinaldi",
    "value": "Marina Rinaldi"
  },
  {
    "label": "Maripé",
    "value": "Maripé"
  },
  {
    "label": "Marjolaine",
    "value": "Marjolaine"
  },
  {
    "label": "Markus Lupfer",
    "value": "Markus Lupfer"
  },
  {
    "label": "Marmot",
    "value": "Marmot"
  },
  {
    "label": "Marshall",
    "value": "Marshall"
  },
  {
    "label": "Maruti",
    "value": "Maruti"
  },
  {
    "label": "Maryan Mehlhorn",
    "value": "Maryan Mehlhorn"
  },
  {
    "label": "Mascara",
    "value": "Mascara"
  },
  {
    "label": "Mascaro",
    "value": "Mascaro"
  },
  {
    "label": "Mason Garments",
    "value": "Mason Garments"
  },
  {
    "label": "Massimo Dutti",
    "value": "Massimo Dutti"
  },
  {
    "label": "Master & Dynamic",
    "value": "Master & Dynamic"
  },
  {
    "label": "Match34",
    "value": "Match34"
  },
  {
    "label": "Matin Studio",
    "value": "Matin Studio"
  },
  {
    "label": "Matt & Nat",
    "value": "Matt & Nat"
  },
  {
    "label": "Maurice Lacroix",
    "value": "Maurice Lacroix"
  },
  {
    "label": "Mavi Shop",
    "value": "Mavi Shop"
  },
  {
    "label": "Mavi",
    "value": "Mavi"
  },
  {
    "label": "Max Mara Hosiery",
    "value": "Max Mara Hosiery"
  },
  {
    "label": "Max Mara Leisure",
    "value": "Max Mara Leisure"
  },
  {
    "label": "Max Mara Shop",
    "value": "Max Mara Shop"
  },
  {
    "label": "Max Mara",
    "value": "Max Mara"
  },
  {
    "label": "MaxMara",
    "value": "MaxMara"
  },
  {
    "label": "Maya Deluxe",
    "value": "Maya Deluxe"
  },
  {
    "label": "Maze",
    "value": "Maze"
  },
  {
    "label": "Maître",
    "value": "Maître"
  },
  {
    "label": "McGregor",
    "value": "McGregor"
  },
  {
    "label": "McQ Alexander McQueen",
    "value": "McQ Alexander McQueen"
  },
  {
    "label": "McQ",
    "value": "McQ"
  },
  {
    "label": "Megumi Ochi",
    "value": "Megumi Ochi"
  },
  {
    "label": "MeisterSinger",
    "value": "MeisterSinger"
  },
  {
    "label": "Mel Ivy",
    "value": "Mel Ivy"
  },
  {
    "label": "Mela London",
    "value": "Mela London"
  },
  {
    "label": "Melissa Odabash",
    "value": "Melissa Odabash"
  },
  {
    "label": "Melissa Shop",
    "value": "Melissa Shop"
  },
  {
    "label": "Melissa",
    "value": "Melissa"
  },
  {
    "label": "Mellow Yellow",
    "value": "Mellow Yellow"
  },
  {
    "label": "Melt",
    "value": "Melt"
  },
  {
    "label": "Melvin & Hamilton",
    "value": "Melvin & Hamilton"
  },
  {
    "label": "Menbur",
    "value": "Menbur"
  },
  {
    "label": "Menil",
    "value": "Menil"
  },
  {
    "label": "Meraki",
    "value": "Meraki"
  },
  {
    "label": "Merchcode",
    "value": "Merchcode"
  },
  {
    "label": "Merrell",
    "value": "Merrell"
  },
  {
    "label": "Meru",
    "value": "Meru"
  },
  {
    "label": "Mes Demoiselles",
    "value": "Mes Demoiselles"
  },
  {
    "label": "Mette Ditmer",
    "value": "Mette Ditmer"
  },
  {
    "label": "Mey",
    "value": "Mey"
  },
  {
    "label": "Michael Kors Access",
    "value": "Michael Kors Access"
  },
  {
    "label": "Michael Kors Shop",
    "value": "Michael Kors Shop"
  },
  {
    "label": "Michael Kors",
    "value": "Michael Kors"
  },
  {
    "label": "Mikoh",
    "value": "Mikoh"
  },
  {
    "label": "Miller Harris",
    "value": "Miller Harris"
  },
  {
    "label": "Millet",
    "value": "Millet"
  },
  {
    "label": "Mimi Holliday",
    "value": "Mimi Holliday"
  },
  {
    "label": "Mimi et Toi",
    "value": "Mimi et Toi"
  },
  {
    "label": "Minelli",
    "value": "Minelli"
  },
  {
    "label": "Minimum",
    "value": "Minimum"
  },
  {
    "label": "Minnetonka",
    "value": "Minnetonka"
  },
  {
    "label": "Mint Velvet",
    "value": "Mint Velvet"
  },
  {
    "label": "Mint&Rose",
    "value": "Mint&Rose"
  },
  {
    "label": "Miraclesuit",
    "value": "Miraclesuit"
  },
  {
    "label": "Mis Pepas",
    "value": "Mis Pepas"
  },
  {
    "label": "Misfit",
    "value": "Misfit"
  },
  {
    "label": "Miss Etam",
    "value": "Miss Etam"
  },
  {
    "label": "Miss KG",
    "value": "Miss KG"
  },
  {
    "label": "Miss Parisienne",
    "value": "Miss Parisienne"
  },
  {
    "label": "Miss Selfridge Petite",
    "value": "Miss Selfridge Petite"
  },
  {
    "label": "Miss Selfridge Shop",
    "value": "Miss Selfridge Shop"
  },
  {
    "label": "Miss Selfridge",
    "value": "Miss Selfridge"
  },
  {
    "label": "Miss Sixty",
    "value": "Miss Sixty"
  },
  {
    "label": "Missguided Petite",
    "value": "Missguided Petite"
  },
  {
    "label": "Missguided Plus",
    "value": "Missguided Plus"
  },
  {
    "label": "Missguided Shop",
    "value": "Missguided Shop"
  },
  {
    "label": "Missguided Tall",
    "value": "Missguided Tall"
  },
  {
    "label": "Missguided",
    "value": "Missguided"
  },
  {
    "label": "Missoni Home",
    "value": "Missoni Home"
  },
  {
    "label": "Missoni Shop",
    "value": "Missoni Shop"
  },
  {
    "label": "Mister Tee",
    "value": "Mister Tee"
  },
  {
    "label": "Miu Miu",
    "value": "Miu Miu"
  },
  {
    "label": "Mizuno",
    "value": "Mizuno"
  },
  {
    "label": "Modern Eternity",
    "value": "Modern Eternity"
  },
  {
    "label": "Modstrom",
    "value": "Modstrom"
  },
  {
    "label": "Modström",
    "value": "Modström"
  },
  {
    "label": "Mogul",
    "value": "Mogul"
  },
  {
    "label": "Moheda Toffeln",
    "value": "Moheda Toffeln"
  },
  {
    "label": "Moleskine",
    "value": "Moleskine"
  },
  {
    "label": "Molly Bracken",
    "value": "Molly Bracken"
  },
  {
    "label": "Molton Brown",
    "value": "Molton Brown"
  },
  {
    "label": "Momokrom",
    "value": "Momokrom"
  },
  {
    "label": "Moncler",
    "value": "Moncler"
  },
  {
    "label": "Monkee Genes",
    "value": "Monkee Genes"
  },
  {
    "label": "Monki",
    "value": "Monki"
  },
  {
    "label": "Mons Royale",
    "value": "Mons Royale"
  },
  {
    "label": "Mont Blanc",
    "value": "Mont Blanc"
  },
  {
    "label": "Montale",
    "value": "Montale"
  },
  {
    "label": "Montblanc",
    "value": "Montblanc"
  },
  {
    "label": "Moon Boot",
    "value": "Moon Boot"
  },
  {
    "label": "Moose Knuckles",
    "value": "Moose Knuckles"
  },
  {
    "label": "More & More",
    "value": "More & More"
  },
  {
    "label": "Moreau",
    "value": "Moreau"
  },
  {
    "label": "Morgan Shop",
    "value": "Morgan Shop"
  },
  {
    "label": "Morgan",
    "value": "Morgan"
  },
  {
    "label": "Moroccanoil",
    "value": "Moroccanoil"
  },
  {
    "label": "Mos Mosh",
    "value": "Mos Mosh"
  },
  {
    "label": "Moschino Underwear",
    "value": "Moschino Underwear"
  },
  {
    "label": "Moscow",
    "value": "Moscow"
  },
  {
    "label": "Moss Copenhagen",
    "value": "Moss Copenhagen"
  },
  {
    "label": "Mossman",
    "value": "Mossman"
  },
  {
    "label": "Mother of Pearl",
    "value": "Mother of Pearl"
  },
  {
    "label": "Mother",
    "value": "Mother"
  },
  {
    "label": "Moves",
    "value": "Moves"
  },
  {
    "label": "Muk Luks",
    "value": "Muk Luks"
  },
  {
    "label": "Munthe",
    "value": "Munthe"
  },
  {
    "label": "Musse & Cloud",
    "value": "Musse & Cloud"
  },
  {
    "label": "Mustang",
    "value": "Mustang"
  },
  {
    "label": "My Mascara Curves",
    "value": "My Mascara Curves"
  },
  {
    "label": "M·A·C",
    "value": "M·A·C"
  },
  {
    "label": "NA-KD",
    "value": "NA-KD"
  },
  {
    "label": "NADEL u FADEN",
    "value": "NADEL u FADEN"
  },
  {
    "label": "NAF NAF",
    "value": "NAF NAF"
  },
  {
    "label": "NALI",
    "value": "NALI"
  },
  {
    "label": "NAME IT",
    "value": "NAME IT"
  },
  {
    "label": "NAPAPIJRI",
    "value": "NAPAPIJRI"
  },
  {
    "label": "NARS",
    "value": "NARS"
  },
  {
    "label": "NEUVILLE",
    "value": "NEUVILLE"
  },
  {
    "label": "NEW ERA",
    "value": "NEW ERA"
  },
  {
    "label": "NEW LOOK",
    "value": "NEW LOOK"
  },
  {
    "label": "NIKE",
    "value": "NIKE"
  },
  {
    "label": "NIKKIE",
    "value": "NIKKIE"
  },
  {
    "label": "NITRO",
    "value": "NITRO"
  },
  {
    "label": "NON COMMUN",
    "value": "NON COMMUN"
  },
  {
    "label": "NORR",
    "value": "NORR"
  },
  {
    "label": "NUANCE",
    "value": "NUANCE"
  },
  {
    "label": "Nailberry",
    "value": "Nailberry"
  },
  {
    "label": "Naketano",
    "value": "Naketano"
  },
  {
    "label": "Nanushka",
    "value": "Nanushka"
  },
  {
    "label": "Napapijri",
    "value": "Napapijri"
  },
  {
    "label": "Narciso Rodriguez",
    "value": "Narciso Rodriguez"
  },
  {
    "label": "Nathalie Vleeschouwer",
    "value": "Nathalie Vleeschouwer"
  },
  {
    "label": "Native Union",
    "value": "Native Union"
  },
  {
    "label": "Native Youth",
    "value": "Native Youth"
  },
  {
    "label": "Native",
    "value": "Native"
  },
  {
    "label": "Natural World",
    "value": "Natural World"
  },
  {
    "label": "Navy London",
    "value": "Navy London"
  },
  {
    "label": "Naïf",
    "value": "Naïf"
  },
  {
    "label": "Needle & Thread",
    "value": "Needle & Thread"
  },
  {
    "label": "Neo Noir",
    "value": "Neo Noir"
  },
  {
    "label": "Neon Rose",
    "value": "Neon Rose"
  },
  {
    "label": "Neosens",
    "value": "Neosens"
  },
  {
    "label": "Neuville",
    "value": "Neuville"
  },
  {
    "label": "Neuw",
    "value": "Neuw"
  },
  {
    "label": "New Balance",
    "value": "New Balance"
  },
  {
    "label": "New Era",
    "value": "New Era"
  },
  {
    "label": "New Look Curves",
    "value": "New Look Curves"
  },
  {
    "label": "New Look Maternity",
    "value": "New Look Maternity"
  },
  {
    "label": "New Look Petite",
    "value": "New Look Petite"
  },
  {
    "label": "New Look Shop",
    "value": "New Look Shop"
  },
  {
    "label": "New Look Tall",
    "value": "New Look Tall"
  },
  {
    "label": "New Look Wide Fit",
    "value": "New Look Wide Fit"
  },
  {
    "label": "New Look",
    "value": "New Look"
  },
  {
    "label": "Newline",
    "value": "Newline"
  },
  {
    "label": "Next",
    "value": "Next"
  },
  {
    "label": "Nico",
    "value": "Nico"
  },
  {
    "label": "Nike Golf",
    "value": "Nike Golf"
  },
  {
    "label": "Nike Performance",
    "value": "Nike Performance"
  },
  {
    "label": "Nike SB",
    "value": "Nike SB"
  },
  {
    "label": "Nike Shop",
    "value": "Nike Shop"
  },
  {
    "label": "Nike Sportswear",
    "value": "Nike Sportswear"
  },
  {
    "label": "Nike Swim",
    "value": "Nike Swim"
  },
  {
    "label": "Nike",
    "value": "Nike"
  },
  {
    "label": "Nikita",
    "value": "Nikita"
  },
  {
    "label": "Nine West",
    "value": "Nine West"
  },
  {
    "label": "Nitro",
    "value": "Nitro"
  },
  {
    "label": "Nixon",
    "value": "Nixon"
  },
  {
    "label": "No Ka'Oi",
    "value": "No Ka'Oi"
  },
  {
    "label": "No Name",
    "value": "No Name"
  },
  {
    "label": "No. 1 Como",
    "value": "No. 1 Como"
  },
  {
    "label": "Noa Noa",
    "value": "Noa Noa"
  },
  {
    "label": "Noclaim",
    "value": "Noclaim"
  },
  {
    "label": "Noisy May Petite",
    "value": "Noisy May Petite"
  },
  {
    "label": "Noisy May Shop",
    "value": "Noisy May Shop"
  },
  {
    "label": "Noisy May Tall",
    "value": "Noisy May Tall"
  },
  {
    "label": "Noisy may",
    "value": "Noisy may"
  },
  {
    "label": "Noppies",
    "value": "Noppies"
  },
  {
    "label": "Norma Kamali",
    "value": "Norma Kamali"
  },
  {
    "label": "North Sails",
    "value": "North Sails"
  },
  {
    "label": "Notes du Nord",
    "value": "Notes du Nord"
  },
  {
    "label": "Nous",
    "value": "Nous"
  },
  {
    "label": "Novesta",
    "value": "Novesta"
  },
  {
    "label": "Noë",
    "value": "Noë"
  },
  {
    "label": "Nubian Skin",
    "value": "Nubian Skin"
  },
  {
    "label": "Nubikk",
    "value": "Nubikk"
  },
  {
    "label": "Nudie Jeans",
    "value": "Nudie Jeans"
  },
  {
    "label": "Nulla Nomen",
    "value": "Nulla Nomen"
  },
  {
    "label": "Nué Notes",
    "value": "Nué Notes"
  },
  {
    "label": "Nümph",
    "value": "Nümph"
  },
  {
    "label": "O My Bag",
    "value": "O My Bag"
  },
  {
    "label": "O'Neill",
    "value": "O'Neill"
  },
  {
    "label": "OAKLEY",
    "value": "OAKLEY"
  },
  {
    "label": "OAKWOOD",
    "value": "OAKWOOD"
  },
  {
    "label": "OBJECT",
    "value": "OBJECT"
  },
  {
    "label": "ODLO",
    "value": "ODLO"
  },
  {
    "label": "OLYMPIA",
    "value": "OLYMPIA"
  },
  {
    "label": "ONLY Carmakoma",
    "value": "ONLY Carmakoma"
  },
  {
    "label": "ONLY PLAY",
    "value": "ONLY PLAY"
  },
  {
    "label": "ONLY Petite",
    "value": "ONLY Petite"
  },
  {
    "label": "ONLY Play",
    "value": "ONLY Play"
  },
  {
    "label": "ONLY SHOES",
    "value": "ONLY SHOES"
  },
  {
    "label": "ONLY Shop",
    "value": "ONLY Shop"
  },
  {
    "label": "ONLY Tall",
    "value": "ONLY Tall"
  },
  {
    "label": "ONLY",
    "value": "ONLY"
  },
  {
    "label": "OOF",
    "value": "OOF"
  },
  {
    "label": "OPUS",
    "value": "OPUS"
  },
  {
    "label": "OUI",
    "value": "OUI"
  },
  {
    "label": "OVS",
    "value": "OVS"
  },
  {
    "label": "OW Intimates",
    "value": "OW Intimates"
  },
  {
    "label": "OYSHO",
    "value": "OYSHO"
  },
  {
    "label": "Oakley",
    "value": "Oakley"
  },
  {
    "label": "Oakwood",
    "value": "Oakwood"
  },
  {
    "label": "Oas",
    "value": "Oas"
  },
  {
    "label": "Oasis",
    "value": "Oasis"
  },
  {
    "label": "Obey Clothing",
    "value": "Obey Clothing"
  },
  {
    "label": "Obey",
    "value": "Obey"
  },
  {
    "label": "Object",
    "value": "Object"
  },
  {
    "label": "Odd Molly",
    "value": "Odd Molly"
  },
  {
    "label": "Off-White",
    "value": "Off-White"
  },
  {
    "label": "Office Shop",
    "value": "Office Shop"
  },
  {
    "label": "Office",
    "value": "Office"
  },
  {
    "label": "Official",
    "value": "Official"
  },
  {
    "label": "Oh My Love",
    "value": "Oh My Love"
  },
  {
    "label": "Oh Yeah!",
    "value": "Oh Yeah!"
  },
  {
    "label": "Oh my Love",
    "value": "Oh my Love"
  },
  {
    "label": "Olivia Burton",
    "value": "Olivia Burton"
  },
  {
    "label": "One Teaspoon",
    "value": "One Teaspoon"
  },
  {
    "label": "Onitsuka Tiger",
    "value": "Onitsuka Tiger"
  },
  {
    "label": "Only & Sons",
    "value": "Only & Sons"
  },
  {
    "label": "Onzie",
    "value": "Onzie"
  },
  {
    "label": "Open End",
    "value": "Open End"
  },
  {
    "label": "Opening Ceremony Shop",
    "value": "Opening Ceremony Shop"
  },
  {
    "label": "Opening Ceremony",
    "value": "Opening Ceremony"
  },
  {
    "label": "Opus",
    "value": "Opus"
  },
  {
    "label": "Orelia",
    "value": "Orelia"
  },
  {
    "label": "Oribe",
    "value": "Oribe"
  },
  {
    "label": "Oroblu",
    "value": "Oroblu"
  },
  {
    "label": "Osprey",
    "value": "Osprey"
  },
  {
    "label": "Otto Kessler",
    "value": "Otto Kessler"
  },
  {
    "label": "Oxitaly",
    "value": "Oxitaly"
  },
  {
    "label": "P-L-D-M by Palladium",
    "value": "P-L-D-M by Palladium"
  },
  {
    "label": "P448",
    "value": "P448"
  },
  {
    "label": "PALMERS",
    "value": "PALMERS"
  },
  {
    "label": "PARFOIS",
    "value": "PARFOIS"
  },
  {
    "label": "PASSIONATA",
    "value": "PASSIONATA"
  },
  {
    "label": "PATAGONIA",
    "value": "PATAGONIA"
  },
  {
    "label": "PAUL & JOE SISTER",
    "value": "PAUL & JOE SISTER"
  },
  {
    "label": "PAULS BOUTIQUE LONDON",
    "value": "PAULS BOUTIQUE LONDON"
  },
  {
    "label": "PAVEMENT",
    "value": "PAVEMENT"
  },
  {
    "label": "PB X LaSalle",
    "value": "PB X LaSalle"
  },
  {
    "label": "PB accessoires",
    "value": "PB accessoires"
  },
  {
    "label": "PEAK PERFORMANCE",
    "value": "PEAK PERFORMANCE"
  },
  {
    "label": "PEP",
    "value": "PEP"
  },
  {
    "label": "PERLATO Shop",
    "value": "PERLATO Shop"
  },
  {
    "label": "PERLATO",
    "value": "PERLATO"
  },
  {
    "label": "PERSEVERANCE LONDON",
    "value": "PERSEVERANCE LONDON"
  },
  {
    "label": "PETITE FLEUR",
    "value": "PETITE FLEUR"
  },
  {
    "label": "PIECES",
    "value": "PIECES"
  },
  {
    "label": "PLEASE",
    "value": "PLEASE"
  },
  {
    "label": "POC",
    "value": "POC"
  },
  {
    "label": "POLARINO",
    "value": "POLARINO"
  },
  {
    "label": "POLER",
    "value": "POLER"
  },
  {
    "label": "POLO RALPH LAUREN",
    "value": "POLO RALPH LAUREN"
  },
  {
    "label": "POM Amsterdam",
    "value": "POM Amsterdam"
  },
  {
    "label": "POPA",
    "value": "POPA"
  },
  {
    "label": "POSTYR",
    "value": "POSTYR"
  },
  {
    "label": "PRETTY BALLERINAS",
    "value": "PRETTY BALLERINAS"
  },
  {
    "label": "PRIMIGI",
    "value": "PRIMIGI"
  },
  {
    "label": "PRINCESS GOES HOLLYWOOD",
    "value": "PRINCESS GOES HOLLYWOOD"
  },
  {
    "label": "PROTEST",
    "value": "PROTEST"
  },
  {
    "label": "PS Poelman",
    "value": "PS Poelman"
  },
  {
    "label": "PS by Paul Smith",
    "value": "PS by Paul Smith"
  },
  {
    "label": "PULL&BEAR",
    "value": "PULL&BEAR"
  },
  {
    "label": "PUMA",
    "value": "PUMA"
  },
  {
    "label": "PYRENEX",
    "value": "PYRENEX"
  },
  {
    "label": "PYUA",
    "value": "PYUA"
  },
  {
    "label": "Packmack",
    "value": "Packmack"
  },
  {
    "label": "Paco Gil",
    "value": "Paco Gil"
  },
  {
    "label": "Paco Rabanne",
    "value": "Paco Rabanne"
  },
  {
    "label": "Paige",
    "value": "Paige"
  },
  {
    "label": "Pain de Sucre",
    "value": "Pain de Sucre"
  },
  {
    "label": "Pairs in Paris",
    "value": "Pairs in Paris"
  },
  {
    "label": "Pajar",
    "value": "Pajar"
  },
  {
    "label": "Palladium",
    "value": "Palladium"
  },
  {
    "label": "Palmers",
    "value": "Palmers"
  },
  {
    "label": "Paloma Barceló",
    "value": "Paloma Barceló"
  },
  {
    "label": "Palomitas by Paloma Barcelo",
    "value": "Palomitas by Paloma Barcelo"
  },
  {
    "label": "Panache",
    "value": "Panache"
  },
  {
    "label": "Panama Jack",
    "value": "Panama Jack"
  },
  {
    "label": "Panara schoenen",
    "value": "Panara schoenen"
  },
  {
    "label": "Pandora",
    "value": "Pandora"
  },
  {
    "label": "Pantone",
    "value": "Pantone"
  },
  {
    "label": "Paper Dolls Curvy",
    "value": "Paper Dolls Curvy"
  },
  {
    "label": "Paper Dolls Shop",
    "value": "Paper Dolls Shop"
  },
  {
    "label": "Paper Dolls",
    "value": "Paper Dolls"
  },
  {
    "label": "Papillio",
    "value": "Papillio"
  },
  {
    "label": "Paradox London Pink",
    "value": "Paradox London Pink"
  },
  {
    "label": "Paradox London Shop",
    "value": "Paradox London Shop"
  },
  {
    "label": "Parkland",
    "value": "Parkland"
  },
  {
    "label": "Part Two",
    "value": "Part Two"
  },
  {
    "label": "Pascal Morabito",
    "value": "Pascal Morabito"
  },
  {
    "label": "Passionata",
    "value": "Passionata"
  },
  {
    "label": "PatBo",
    "value": "PatBo"
  },
  {
    "label": "Patagonia",
    "value": "Patagonia"
  },
  {
    "label": "Pataugas",
    "value": "Pataugas"
  },
  {
    "label": "Patrizia Pepe Shop",
    "value": "Patrizia Pepe Shop"
  },
  {
    "label": "Patrizia Pepe",
    "value": "Patrizia Pepe"
  },
  {
    "label": "Paul & Joe Shop",
    "value": "Paul & Joe Shop"
  },
  {
    "label": "Paul & Joe Sister",
    "value": "Paul & Joe Sister"
  },
  {
    "label": "Paul Hewitt",
    "value": "Paul Hewitt"
  },
  {
    "label": "Paul Smith Accessories",
    "value": "Paul Smith Accessories"
  },
  {
    "label": "Paul Smith Shop",
    "value": "Paul Smith Shop"
  },
  {
    "label": "Paul Smith",
    "value": "Paul Smith"
  },
  {
    "label": "Paule Ka",
    "value": "Paule Ka"
  },
  {
    "label": "Paulina",
    "value": "Paulina"
  },
  {
    "label": "Pavement",
    "value": "Pavement"
  },
  {
    "label": "Peak Performance Shop",
    "value": "Peak Performance Shop"
  },
  {
    "label": "Peak Performance",
    "value": "Peak Performance"
  },
  {
    "label": "Pearl Izumi",
    "value": "Pearl Izumi"
  },
  {
    "label": "Pedag",
    "value": "Pedag"
  },
  {
    "label": "Pedro García",
    "value": "Pedro García"
  },
  {
    "label": "Pedro Miralles",
    "value": "Pedro Miralles"
  },
  {
    "label": "Penfield",
    "value": "Penfield"
  },
  {
    "label": "Pepe Jeans Shop",
    "value": "Pepe Jeans Shop"
  },
  {
    "label": "Pepe Jeans",
    "value": "Pepe Jeans"
  },
  {
    "label": "Pepen Sole",
    "value": "Pepen Sole"
  },
  {
    "label": "Pernille Corydon",
    "value": "Pernille Corydon"
  },
  {
    "label": "Perricone MD",
    "value": "Perricone MD"
  },
  {
    "label": "Persol",
    "value": "Persol"
  },
  {
    "label": "Persona by Marina Rinaldi",
    "value": "Persona by Marina Rinaldi"
  },
  {
    "label": "Peter Kaiser Wide Fit",
    "value": "Peter Kaiser Wide Fit"
  },
  {
    "label": "Peter Kaiser",
    "value": "Peter Kaiser"
  },
  {
    "label": "Petit Bateau Dames",
    "value": "Petit Bateau Dames"
  },
  {
    "label": "Petit Bateau",
    "value": "Petit Bateau"
  },
  {
    "label": "Peuterey",
    "value": "Peuterey"
  },
  {
    "label": "Phase Eight",
    "value": "Phase Eight"
  },
  {
    "label": "Philippe Model",
    "value": "Philippe Model"
  },
  {
    "label": "Philomijn",
    "value": "Philomijn"
  },
  {
    "label": "Phyne",
    "value": "Phyne"
  },
  {
    "label": "Piazza Sempione",
    "value": "Piazza Sempione"
  },
  {
    "label": "Picard",
    "value": "Picard"
  },
  {
    "label": "Picture Organic Clothing",
    "value": "Picture Organic Clothing"
  },
  {
    "label": "Pieces Shop",
    "value": "Pieces Shop"
  },
  {
    "label": "Pieces",
    "value": "Pieces"
  },
  {
    "label": "Pier One Shop",
    "value": "Pier One Shop"
  },
  {
    "label": "Pier One Wide Fit",
    "value": "Pier One Wide Fit"
  },
  {
    "label": "Pier One",
    "value": "Pier One"
  },
  {
    "label": "Pierre Balmain",
    "value": "Pierre Balmain"
  },
  {
    "label": "Pierre Cardin",
    "value": "Pierre Cardin"
  },
  {
    "label": "Pietro Brunelli",
    "value": "Pietro Brunelli"
  },
  {
    "label": "Piggy Proof",
    "value": "Piggy Proof"
  },
  {
    "label": "Pilgrim",
    "value": "Pilgrim"
  },
  {
    "label": "PilyQ",
    "value": "PilyQ"
  },
  {
    "label": "Pink Clove",
    "value": "Pink Clove"
  },
  {
    "label": "Pinko Jean",
    "value": "Pinko Jean"
  },
  {
    "label": "Pinko",
    "value": "Pinko"
  },
  {
    "label": "Pinto Di Blu",
    "value": "Pinto Di Blu"
  },
  {
    "label": "Piola",
    "value": "Piola"
  },
  {
    "label": "Pioneer Authentic Jeans",
    "value": "Pioneer Authentic Jeans"
  },
  {
    "label": "Pip Studio",
    "value": "Pip Studio"
  },
  {
    "label": "Piquadro",
    "value": "Piquadro"
  },
  {
    "label": "Pistol Panties",
    "value": "Pistol Panties"
  },
  {
    "label": "Pitusa",
    "value": "Pitusa"
  },
  {
    "label": "Playful Motion Curve",
    "value": "Playful Motion Curve"
  },
  {
    "label": "Playful Promises",
    "value": "Playful Promises"
  },
  {
    "label": "Plein Publique",
    "value": "Plein Publique"
  },
  {
    "label": "Plein Sud Jeanius",
    "value": "Plein Sud Jeanius"
  },
  {
    "label": "Plein Sud Shop",
    "value": "Plein Sud Shop"
  },
  {
    "label": "Polar",
    "value": "Polar"
  },
  {
    "label": "Polaroid",
    "value": "Polaroid"
  },
  {
    "label": "Pollini",
    "value": "Pollini"
  },
  {
    "label": "Polo Ralph Lauren Golf",
    "value": "Polo Ralph Lauren Golf"
  },
  {
    "label": "Polo Ralph Lauren",
    "value": "Polo Ralph Lauren"
  },
  {
    "label": "Pomandere",
    "value": "Pomandere"
  },
  {
    "label": "Pomandère",
    "value": "Pomandère"
  },
  {
    "label": "Pomkin",
    "value": "Pomkin"
  },
  {
    "label": "Pons Quintana",
    "value": "Pons Quintana"
  },
  {
    "label": "Pop Copenhagen",
    "value": "Pop Copenhagen"
  },
  {
    "label": "Porsche Design",
    "value": "Porsche Design"
  },
  {
    "label": "Ports 1961",
    "value": "Ports 1961"
  },
  {
    "label": "Pour Moi",
    "value": "Pour Moi"
  },
  {
    "label": "PrAna",
    "value": "PrAna"
  },
  {
    "label": "Prada",
    "value": "Prada"
  },
  {
    "label": "Pretty Ballerinas",
    "value": "Pretty Ballerinas"
  },
  {
    "label": "Pretty Polly",
    "value": "Pretty Polly"
  },
  {
    "label": "Pretty Shop",
    "value": "Pretty Shop"
  },
  {
    "label": "Prima Donna Swim",
    "value": "Prima Donna Swim"
  },
  {
    "label": "Prima Donna Twist",
    "value": "Prima Donna Twist"
  },
  {
    "label": "Prima Donna",
    "value": "Prima Donna"
  },
  {
    "label": "Primadonna Collection",
    "value": "Primadonna Collection"
  },
  {
    "label": "Princess goes Hollywood",
    "value": "Princess goes Hollywood"
  },
  {
    "label": "Princesse tam.tam",
    "value": "Princesse tam.tam"
  },
  {
    "label": "Pro-Keds",
    "value": "Pro-Keds"
  },
  {
    "label": "Proenza Schouler",
    "value": "Proenza Schouler"
  },
  {
    "label": "Project AJ117",
    "value": "Project AJ117"
  },
  {
    "label": "Project Delray",
    "value": "Project Delray"
  },
  {
    "label": "Promiss",
    "value": "Promiss"
  },
  {
    "label": "Protest",
    "value": "Protest"
  },
  {
    "label": "Public Desire",
    "value": "Public Desire"
  },
  {
    "label": "Puma Golf",
    "value": "Puma Golf"
  },
  {
    "label": "Puma Shop",
    "value": "Puma Shop"
  },
  {
    "label": "Puma X Fenty",
    "value": "Puma X Fenty"
  },
  {
    "label": "Puma",
    "value": "Puma"
  },
  {
    "label": "Pura Lopez",
    "value": "Pura Lopez"
  },
  {
    "label": "Q/S designed by",
    "value": "Q/S designed by"
  },
  {
    "label": "QUAY AUSTRALIA",
    "value": "QUAY AUSTRALIA"
  },
  {
    "label": "QUAY",
    "value": "QUAY"
  },
  {
    "label": "QUEEN MUM",
    "value": "QUEEN MUM"
  },
  {
    "label": "QUIKSILVER",
    "value": "QUIKSILVER"
  },
  {
    "label": "Queen Mum",
    "value": "Queen Mum"
  },
  {
    "label": "Quiksilver",
    "value": "Quiksilver"
  },
  {
    "label": "RACHEL Rachel Roy Curvy",
    "value": "RACHEL Rachel Roy Curvy"
  },
  {
    "label": "RAID Wide Fit",
    "value": "RAID Wide Fit"
  },
  {
    "label": "RAINS",
    "value": "RAINS"
  },
  {
    "label": "RALPH Ralph Lauren",
    "value": "RALPH Ralph Lauren"
  },
  {
    "label": "RAS",
    "value": "RAS"
  },
  {
    "label": "REEBOK",
    "value": "REEBOK"
  },
  {
    "label": "REIKO",
    "value": "REIKO"
  },
  {
    "label": "REN Clean Skincare",
    "value": "REN Clean Skincare"
  },
  {
    "label": "RENÉ LEZARD",
    "value": "RENÉ LEZARD"
  },
  {
    "label": "REPLAY",
    "value": "REPLAY"
  },
  {
    "label": "RICHTER",
    "value": "RICHTER"
  },
  {
    "label": "RIEKER",
    "value": "RIEKER"
  },
  {
    "label": "RINO & PELLE",
    "value": "RINO & PELLE"
  },
  {
    "label": "RIP CURL",
    "value": "RIP CURL"
  },
  {
    "label": "RIPNDIP",
    "value": "RIPNDIP"
  },
  {
    "label": "RISY&JERFS",
    "value": "RISY&JERFS"
  },
  {
    "label": "RIVIERAS",
    "value": "RIVIERAS"
  },
  {
    "label": "RMS Beauty",
    "value": "RMS Beauty"
  },
  {
    "label": "ROCKAMORA",
    "value": "ROCKAMORA"
  },
  {
    "label": "ROMIKA",
    "value": "ROMIKA"
  },
  {
    "label": "ROXY",
    "value": "ROXY"
  },
  {
    "label": "ROYAL REPUBLIQ",
    "value": "ROYAL REPUBLIQ"
  },
  {
    "label": "ROYAL-EGO",
    "value": "ROYAL-EGO"
  },
  {
    "label": "RUE de FEMME",
    "value": "RUE de FEMME"
  },
  {
    "label": "RVCA",
    "value": "RVCA"
  },
  {
    "label": "RYE",
    "value": "RYE"
  },
  {
    "label": "Rabens Saloner",
    "value": "Rabens Saloner"
  },
  {
    "label": "Rachel Zoe",
    "value": "Rachel Zoe"
  },
  {
    "label": "Radà",
    "value": "Radà"
  },
  {
    "label": "Rag & Bone / Jean",
    "value": "Rag & Bone / Jean"
  },
  {
    "label": "Rag & Bone",
    "value": "Rag & Bone"
  },
  {
    "label": "Ragdoll LA",
    "value": "Ragdoll LA"
  },
  {
    "label": "Ragwear Plus",
    "value": "Ragwear Plus"
  },
  {
    "label": "Ragwear",
    "value": "Ragwear"
  },
  {
    "label": "Rahua",
    "value": "Rahua"
  },
  {
    "label": "Raid Shop",
    "value": "Raid Shop"
  },
  {
    "label": "Rails",
    "value": "Rails"
  },
  {
    "label": "Rains",
    "value": "Rains"
  },
  {
    "label": "Raiski",
    "value": "Raiski"
  },
  {
    "label": "Ralph Lauren Shop",
    "value": "Ralph Lauren Shop"
  },
  {
    "label": "Ralph Lauren",
    "value": "Ralph Lauren"
  },
  {
    "label": "Rapisardi",
    "value": "Rapisardi"
  },
  {
    "label": "Rare London",
    "value": "Rare London"
  },
  {
    "label": "Rawrow",
    "value": "Rawrow"
  },
  {
    "label": "Ray-Ban",
    "value": "Ray-Ban"
  },
  {
    "label": "Raymond Weil",
    "value": "Raymond Weil"
  },
  {
    "label": "Real Techniques",
    "value": "Real Techniques"
  },
  {
    "label": "Rebecca Minkoff",
    "value": "Rebecca Minkoff"
  },
  {
    "label": "Red Valentino",
    "value": "Red Valentino"
  },
  {
    "label": "Reebok Classic",
    "value": "Reebok Classic"
  },
  {
    "label": "Reebok Shop",
    "value": "Reebok Shop"
  },
  {
    "label": "Reebok classic",
    "value": "Reebok classic"
  },
  {
    "label": "Reebok",
    "value": "Reebok"
  },
  {
    "label": "Reef",
    "value": "Reef"
  },
  {
    "label": "Refresh",
    "value": "Refresh"
  },
  {
    "label": "Regatta",
    "value": "Regatta"
  },
  {
    "label": "Reiss",
    "value": "Reiss"
  },
  {
    "label": "Religion",
    "value": "Religion"
  },
  {
    "label": "Remonte",
    "value": "Remonte"
  },
  {
    "label": "Renard",
    "value": "Renard"
  },
  {
    "label": "Repeat Cashmere",
    "value": "Repeat Cashmere"
  },
  {
    "label": "Repeat",
    "value": "Repeat"
  },
  {
    "label": "Replay",
    "value": "Replay"
  },
  {
    "label": "Resort Finest",
    "value": "Resort Finest"
  },
  {
    "label": "Reusch",
    "value": "Reusch"
  },
  {
    "label": "Review",
    "value": "Review"
  },
  {
    "label": "Rich & Royal",
    "value": "Rich & Royal"
  },
  {
    "label": "Richmond & Finch",
    "value": "Richmond & Finch"
  },
  {
    "label": "Ridgebake",
    "value": "Ridgebake"
  },
  {
    "label": "Rieker",
    "value": "Rieker"
  },
  {
    "label": "Rimowa",
    "value": "Rimowa"
  },
  {
    "label": "Rip Curl",
    "value": "Rip Curl"
  },
  {
    "label": "Ripe",
    "value": "Ripe"
  },
  {
    "label": "River Island",
    "value": "River Island"
  },
  {
    "label": "River Woods",
    "value": "River Woods"
  },
  {
    "label": "Robako",
    "value": "Robako"
  },
  {
    "label": "Robert Piguet",
    "value": "Robert Piguet"
  },
  {
    "label": "Roberto Cavalli Shop",
    "value": "Roberto Cavalli Shop"
  },
  {
    "label": "Roberto Collina",
    "value": "Roberto Collina"
  },
  {
    "label": "Roeckl Shop",
    "value": "Roeckl Shop"
  },
  {
    "label": "Roeckl Sports",
    "value": "Roeckl Sports"
  },
  {
    "label": "Roeckl",
    "value": "Roeckl"
  },
  {
    "label": "Roja Dove",
    "value": "Roja Dove"
  },
  {
    "label": "Rojo",
    "value": "Rojo"
  },
  {
    "label": "Roland Mouret",
    "value": "Roland Mouret"
  },
  {
    "label": "Rolla's",
    "value": "Rolla's"
  },
  {
    "label": "Rollie",
    "value": "Rollie"
  },
  {
    "label": "Roncato",
    "value": "Roncato"
  },
  {
    "label": "Roosevelt",
    "value": "Roosevelt"
  },
  {
    "label": "Rosa & Me",
    "value": "Rosa & Me"
  },
  {
    "label": "Rosantica",
    "value": "Rosantica"
  },
  {
    "label": "Rosefield",
    "value": "Rosefield"
  },
  {
    "label": "Rosemunde",
    "value": "Rosemunde"
  },
  {
    "label": "Rosner",
    "value": "Rosner"
  },
  {
    "label": "Rossignol Apparel",
    "value": "Rossignol Apparel"
  },
  {
    "label": "Roxy",
    "value": "Roxy"
  },
  {
    "label": "Royal RepubliQ",
    "value": "Royal RepubliQ"
  },
  {
    "label": "Ruby Tuesday",
    "value": "Ruby Tuesday"
  },
  {
    "label": "Ruby+Ed",
    "value": "Ruby+Ed"
  },
  {
    "label": "Rue de Femme",
    "value": "Rue de Femme"
  },
  {
    "label": "Rukka",
    "value": "Rukka"
  },
  {
    "label": "Russell Athletic",
    "value": "Russell Athletic"
  },
  {
    "label": "Rut & Circle",
    "value": "Rut & Circle"
  },
  {
    "label": "Résumé",
    "value": "Résumé"
  },
  {
    "label": "Röhnisch",
    "value": "Röhnisch"
  },
  {
    "label": "SAHA",
    "value": "SAHA"
  },
  {
    "label": "SAINT TROPEZ",
    "value": "SAINT TROPEZ"
  },
  {
    "label": "SALOMON",
    "value": "SALOMON"
  },
  {
    "label": "SAMOON",
    "value": "SAMOON"
  },
  {
    "label": "SANDQVIST",
    "value": "SANDQVIST"
  },
  {
    "label": "SAVAGE X FENTY",
    "value": "SAVAGE X FENTY"
  },
  {
    "label": "SAVE THE DUCK",
    "value": "SAVE THE DUCK"
  },
  {
    "label": "SCHIESSER",
    "value": "SCHIESSER"
  },
  {
    "label": "SCOTCH & SODA",
    "value": "SCOTCH & SODA"
  },
  {
    "label": "SECOND FEMALE",
    "value": "SECOND FEMALE"
  },
  {
    "label": "SELECTED FEMME",
    "value": "SELECTED FEMME"
  },
  {
    "label": "SELECTED HOMME",
    "value": "SELECTED HOMME"
  },
  {
    "label": "SET",
    "value": "SET"
  },
  {
    "label": "SHABBIES AMSTERDAM",
    "value": "SHABBIES AMSTERDAM"
  },
  {
    "label": "SHISHA",
    "value": "SHISHA"
  },
  {
    "label": "SHOCK ABSORBER",
    "value": "SHOCK ABSORBER"
  },
  {
    "label": "SHOEPASSION",
    "value": "SHOEPASSION"
  },
  {
    "label": "SISTA GLAM PETITE",
    "value": "SISTA GLAM PETITE"
  },
  {
    "label": "SISTA GLAM Shop",
    "value": "SISTA GLAM Shop"
  },
  {
    "label": "SISTERS POINT",
    "value": "SISTERS POINT"
  },
  {
    "label": "SK86",
    "value": "SK86"
  },
  {
    "label": "SKECHERS",
    "value": "SKECHERS"
  },
  {
    "label": "SLUIZ. Ibiza",
    "value": "SLUIZ. Ibiza"
  },
  {
    "label": "SNÖ of Sweden",
    "value": "SNÖ of Sweden"
  },
  {
    "label": "SO COSI",
    "value": "SO COSI"
  },
  {
    "label": "SOAKED IN LUXURY",
    "value": "SOAKED IN LUXURY"
  },
  {
    "label": "SOAP RECOMMENDS",
    "value": "SOAP RECOMMENDS"
  },
  {
    "label": "SOREL",
    "value": "SOREL"
  },
  {
    "label": "SPANX",
    "value": "SPANX"
  },
  {
    "label": "SPEEDO",
    "value": "SPEEDO"
  },
  {
    "label": "SPM",
    "value": "SPM"
  },
  {
    "label": "STEVE MADDEN",
    "value": "STEVE MADDEN"
  },
  {
    "label": "STOCKERPOINT",
    "value": "STOCKERPOINT"
  },
  {
    "label": "STREET ONE",
    "value": "STREET ONE"
  },
  {
    "label": "STRELLSON",
    "value": "STRELLSON"
  },
  {
    "label": "STUDIO ID",
    "value": "STUDIO ID"
  },
  {
    "label": "STUDIO by ONLY",
    "value": "STUDIO by ONLY"
  },
  {
    "label": "SUDDENLY princess",
    "value": "SUDDENLY princess"
  },
  {
    "label": "SUITSUIT",
    "value": "SUITSUIT"
  },
  {
    "label": "SUNDAY IN BED.",
    "value": "SUNDAY IN BED."
  },
  {
    "label": "SUNFLAIR",
    "value": "SUNFLAIR"
  },
  {
    "label": "SUNSEEKER",
    "value": "SUNSEEKER"
  },
  {
    "label": "SUPERGA",
    "value": "SUPERGA"
  },
  {
    "label": "SUPRA",
    "value": "SUPRA"
  },
  {
    "label": "SURI FREY",
    "value": "SURI FREY"
  },
  {
    "label": "SWING",
    "value": "SWING"
  },
  {
    "label": "Sabrina Dehoff",
    "value": "Sabrina Dehoff"
  },
  {
    "label": "Sacai",
    "value": "Sacai"
  },
  {
    "label": "Saint James",
    "value": "Saint James"
  },
  {
    "label": "Saint Laurent",
    "value": "Saint Laurent"
  },
  {
    "label": "Saint Noir",
    "value": "Saint Noir"
  },
  {
    "label": "Saint Tropez",
    "value": "Saint Tropez"
  },
  {
    "label": "Salewa",
    "value": "Salewa"
  },
  {
    "label": "Salomon",
    "value": "Salomon"
  },
  {
    "label": "Salvatore Ferragamo",
    "value": "Salvatore Ferragamo"
  },
  {
    "label": "Salzen",
    "value": "Salzen"
  },
  {
    "label": "Sam Edelman",
    "value": "Sam Edelman"
  },
  {
    "label": "Samsoe & Samsoe",
    "value": "Samsoe & Samsoe"
  },
  {
    "label": "Samsonite Red",
    "value": "Samsonite Red"
  },
  {
    "label": "Samsonite",
    "value": "Samsonite"
  },
  {
    "label": "Samsøe & Samsøe",
    "value": "Samsøe & Samsøe"
  },
  {
    "label": "San Marina",
    "value": "San Marina"
  },
  {
    "label": "Sand Copenhagen",
    "value": "Sand Copenhagen"
  },
  {
    "label": "Sandqvist",
    "value": "Sandqvist"
  },
  {
    "label": "Sandro",
    "value": "Sandro"
  },
  {
    "label": "Sandwich",
    "value": "Sandwich"
  },
  {
    "label": "Sanita",
    "value": "Sanita"
  },
  {
    "label": "Sans Complexe",
    "value": "Sans Complexe"
  },
  {
    "label": "Sanuk",
    "value": "Sanuk"
  },
  {
    "label": "Sapph",
    "value": "Sapph"
  },
  {
    "label": "Sara'",
    "value": "Sara'"
  },
  {
    "label": "Sargossa",
    "value": "Sargossa"
  },
  {
    "label": "Satch",
    "value": "Satch"
  },
  {
    "label": "Saucony",
    "value": "Saucony"
  },
  {
    "label": "Save the duck",
    "value": "Save the duck"
  },
  {
    "label": "Scapa",
    "value": "Scapa"
  },
  {
    "label": "Scarpa",
    "value": "Scarpa"
  },
  {
    "label": "Schiesser Revival",
    "value": "Schiesser Revival"
  },
  {
    "label": "Schiesser Shop",
    "value": "Schiesser Shop"
  },
  {
    "label": "Schiesser",
    "value": "Schiesser"
  },
  {
    "label": "Schmuddelwedda",
    "value": "Schmuddelwedda"
  },
  {
    "label": "Schott NYC",
    "value": "Schott NYC"
  },
  {
    "label": "Schutz",
    "value": "Schutz"
  },
  {
    "label": "Schöffel",
    "value": "Schöffel"
  },
  {
    "label": "Scotch & Soda Shop",
    "value": "Scotch & Soda Shop"
  },
  {
    "label": "Scotch & Soda",
    "value": "Scotch & Soda"
  },
  {
    "label": "Scotch R'Belle",
    "value": "Scotch R'Belle"
  },
  {
    "label": "Scotch&Soda",
    "value": "Scotch&Soda"
  },
  {
    "label": "Seafolly",
    "value": "Seafolly"
  },
  {
    "label": "Second Female",
    "value": "Second Female"
  },
  {
    "label": "Second Script Curve",
    "value": "Second Script Curve"
  },
  {
    "label": "Second Script Petite",
    "value": "Second Script Petite"
  },
  {
    "label": "Secrid",
    "value": "Secrid"
  },
  {
    "label": "See By Chloé",
    "value": "See By Chloé"
  },
  {
    "label": "See U Soon",
    "value": "See U Soon"
  },
  {
    "label": "See by Chloé",
    "value": "See by Chloé"
  },
  {
    "label": "See u Soon",
    "value": "See u Soon"
  },
  {
    "label": "Seidensticker Shop",
    "value": "Seidensticker Shop"
  },
  {
    "label": "Seidensticker",
    "value": "Seidensticker"
  },
  {
    "label": "Seiko",
    "value": "Seiko"
  },
  {
    "label": "Selected Femme",
    "value": "Selected Femme"
  },
  {
    "label": "Self-Portrait",
    "value": "Self-Portrait"
  },
  {
    "label": "Sennheiser",
    "value": "Sennheiser"
  },
  {
    "label": "Senso",
    "value": "Senso"
  },
  {
    "label": "Senz",
    "value": "Senz"
  },
  {
    "label": "Seraphine",
    "value": "Seraphine"
  },
  {
    "label": "Serge Lutens",
    "value": "Serge Lutens"
  },
  {
    "label": "Sessun",
    "value": "Sessun"
  },
  {
    "label": "Seven Boot Lane",
    "value": "Seven Boot Lane"
  },
  {
    "label": "Shabbies Amsterdam",
    "value": "Shabbies Amsterdam"
  },
  {
    "label": "Shellys London",
    "value": "Shellys London"
  },
  {
    "label": "Shepherd",
    "value": "Shepherd"
  },
  {
    "label": "Shimano",
    "value": "Shimano"
  },
  {
    "label": "Shiseido",
    "value": "Shiseido"
  },
  {
    "label": "Shiwi",
    "value": "Shiwi"
  },
  {
    "label": "Shock Absorber",
    "value": "Shock Absorber"
  },
  {
    "label": "Shoe The Bear",
    "value": "Shoe The Bear"
  },
  {
    "label": "Short Stories",
    "value": "Short Stories"
  },
  {
    "label": "Sibin/Linnebjerg",
    "value": "Sibin/Linnebjerg"
  },
  {
    "label": "Sigerson Morrison",
    "value": "Sigerson Morrison"
  },
  {
    "label": "Silver Bloom",
    "value": "Silver Bloom"
  },
  {
    "label": "Simeone Gloves",
    "value": "Simeone Gloves"
  },
  {
    "label": "Simone Pérèle",
    "value": "Simone Pérèle"
  },
  {
    "label": "Simply Be Shop",
    "value": "Simply Be Shop"
  },
  {
    "label": "Simply Be",
    "value": "Simply Be"
  },
  {
    "label": "Sincerely Jules",
    "value": "Sincerely Jules"
  },
  {
    "label": "Sioux",
    "value": "Sioux"
  },
  {
    "label": "Sisley",
    "value": "Sisley"
  },
  {
    "label": "Sista Glam",
    "value": "Sista Glam"
  },
  {
    "label": "Sister Jane",
    "value": "Sister Jane"
  },
  {
    "label": "Six Ames",
    "value": "Six Ames"
  },
  {
    "label": "Sixtyseven",
    "value": "Sixtyseven"
  },
  {
    "label": "Siyu",
    "value": "Siyu"
  },
  {
    "label": "Skagen Connected",
    "value": "Skagen Connected"
  },
  {
    "label": "Skagen",
    "value": "Skagen"
  },
  {
    "label": "Skechers Performance",
    "value": "Skechers Performance"
  },
  {
    "label": "Skechers Shop",
    "value": "Skechers Shop"
  },
  {
    "label": "Skechers Sport",
    "value": "Skechers Sport"
  },
  {
    "label": "Skechers",
    "value": "Skechers"
  },
  {
    "label": "Skinnydip",
    "value": "Skinnydip"
  },
  {
    "label": "Skins",
    "value": "Skins"
  },
  {
    "label": "Skiny",
    "value": "Skiny"
  },
  {
    "label": "Skullcandy",
    "value": "Skullcandy"
  },
  {
    "label": "Slacks & Co.",
    "value": "Slacks & Co."
  },
  {
    "label": "Sloggi",
    "value": "Sloggi"
  },
  {
    "label": "Slydes",
    "value": "Slydes"
  },
  {
    "label": "Smart Hands",
    "value": "Smart Hands"
  },
  {
    "label": "Smarteez",
    "value": "Smarteez"
  },
  {
    "label": "Smartwool",
    "value": "Smartwool"
  },
  {
    "label": "Smash",
    "value": "Smash"
  },
  {
    "label": "Smith Optics",
    "value": "Smith Optics"
  },
  {
    "label": "Snap Inc.",
    "value": "Snap Inc."
  },
  {
    "label": "Sneaky Steve",
    "value": "Sneaky Steve"
  },
  {
    "label": "Snurk",
    "value": "Snurk"
  },
  {
    "label": "Soaked in Luxury",
    "value": "Soaked in Luxury"
  },
  {
    "label": "Sofie Schnoor",
    "value": "Sofie Schnoor"
  },
  {
    "label": "Soft Rebels",
    "value": "Soft Rebels"
  },
  {
    "label": "Softclox",
    "value": "Softclox"
  },
  {
    "label": "Sol Sana",
    "value": "Sol Sana"
  },
  {
    "label": "Solid & Striped",
    "value": "Solid & Striped"
  },
  {
    "label": "Solillas",
    "value": "Solillas"
  },
  {
    "label": "Soludos",
    "value": "Soludos"
  },
  {
    "label": "Somedays Lovin",
    "value": "Somedays Lovin"
  },
  {
    "label": "Sonia Rykiel Shop",
    "value": "Sonia Rykiel Shop"
  },
  {
    "label": "Sonia Rykiel",
    "value": "Sonia Rykiel"
  },
  {
    "label": "Sonia by Sonia Rykiel",
    "value": "Sonia by Sonia Rykiel"
  },
  {
    "label": "Soniush",
    "value": "Soniush"
  },
  {
    "label": "Sorel",
    "value": "Sorel"
  },
  {
    "label": "South Beach",
    "value": "South Beach"
  },
  {
    "label": "Soyaconcept",
    "value": "Soyaconcept"
  },
  {
    "label": "Spanx Shapewear",
    "value": "Spanx Shapewear"
  },
  {
    "label": "Spanx",
    "value": "Spanx"
  },
  {
    "label": "Sparkz",
    "value": "Sparkz"
  },
  {
    "label": "Speedo",
    "value": "Speedo"
  },
  {
    "label": "Spikes & Sparrow",
    "value": "Spikes & Sparrow"
  },
  {
    "label": "Spiral Bags",
    "value": "Spiral Bags"
  },
  {
    "label": "Spoom",
    "value": "Spoom"
  },
  {
    "label": "Sportmax Code",
    "value": "Sportmax Code"
  },
  {
    "label": "Sportmax",
    "value": "Sportmax"
  },
  {
    "label": "Spring Maternity",
    "value": "Spring Maternity"
  },
  {
    "label": "Springfield",
    "value": "Springfield"
  },
  {
    "label": "Springyard",
    "value": "Springyard"
  },
  {
    "label": "Spyder",
    "value": "Spyder"
  },
  {
    "label": "Stance",
    "value": "Stance"
  },
  {
    "label": "Stand",
    "value": "Stand"
  },
  {
    "label": "Starry Eyed",
    "value": "Starry Eyed"
  },
  {
    "label": "State of Elevenate",
    "value": "State of Elevenate"
  },
  {
    "label": "Steamery Stockholm",
    "value": "Steamery Stockholm"
  },
  {
    "label": "Steamery",
    "value": "Steamery"
  },
  {
    "label": "Stefanel",
    "value": "Stefanel"
  },
  {
    "label": "Steffen Schraut",
    "value": "Steffen Schraut"
  },
  {
    "label": "Stella McCartney",
    "value": "Stella McCartney"
  },
  {
    "label": "Stella Nova",
    "value": "Stella Nova"
  },
  {
    "label": "Steps",
    "value": "Steps"
  },
  {
    "label": "Steve J & Yoni P / SJYP",
    "value": "Steve J & Yoni P / SJYP"
  },
  {
    "label": "Steve Madden",
    "value": "Steve Madden"
  },
  {
    "label": "Still Nordic",
    "value": "Still Nordic"
  },
  {
    "label": "Stills",
    "value": "Stills"
  },
  {
    "label": "Stine Goya",
    "value": "Stine Goya"
  },
  {
    "label": "Stonefly",
    "value": "Stonefly"
  },
  {
    "label": "Storm & Marie",
    "value": "Storm & Marie"
  },
  {
    "label": "Story Of Lola",
    "value": "Story Of Lola"
  },
  {
    "label": "Stratic",
    "value": "Stratic"
  },
  {
    "label": "Street One",
    "value": "Street One"
  },
  {
    "label": "Strellson",
    "value": "Strellson"
  },
  {
    "label": "Strenesse",
    "value": "Strenesse"
  },
  {
    "label": "Stuart Weitzman",
    "value": "Stuart Weitzman"
  },
  {
    "label": "Studio 75",
    "value": "Studio 75"
  },
  {
    "label": "Studio 8",
    "value": "Studio 8"
  },
  {
    "label": "Studio Modd",
    "value": "Studio Modd"
  },
  {
    "label": "StudioRUIG",
    "value": "StudioRUIG"
  },
  {
    "label": "Stutterheim",
    "value": "Stutterheim"
  },
  {
    "label": "Style Butler",
    "value": "Style Butler"
  },
  {
    "label": "Stylesnob",
    "value": "Stylesnob"
  },
  {
    "label": "Sublevel",
    "value": "Sublevel"
  },
  {
    "label": "Suboo",
    "value": "Suboo"
  },
  {
    "label": "Suncoo",
    "value": "Suncoo"
  },
  {
    "label": "Sundry",
    "value": "Sundry"
  },
  {
    "label": "Sunnylife",
    "value": "Sunnylife"
  },
  {
    "label": "Sunseeker",
    "value": "Sunseeker"
  },
  {
    "label": "Superdry",
    "value": "Superdry"
  },
  {
    "label": "Superga",
    "value": "Superga"
  },
  {
    "label": "Supermom",
    "value": "Supermom"
  },
  {
    "label": "Supra",
    "value": "Supra"
  },
  {
    "label": "Suri Frey",
    "value": "Suri Frey"
  },
  {
    "label": "Susan Bijl",
    "value": "Susan Bijl"
  },
  {
    "label": "Suunto",
    "value": "Suunto"
  },
  {
    "label": "Svea",
    "value": "Svea"
  },
  {
    "label": "Swarovski",
    "value": "Swarovski"
  },
  {
    "label": "Swatch",
    "value": "Swatch"
  },
  {
    "label": "Swedish Hasbeens",
    "value": "Swedish Hasbeens"
  },
  {
    "label": "Swedish Stockings",
    "value": "Swedish Stockings"
  },
  {
    "label": "Swedish hasbeens",
    "value": "Swedish hasbeens"
  },
  {
    "label": "Swildens",
    "value": "Swildens"
  },
  {
    "label": "Swing Curve",
    "value": "Swing Curve"
  },
  {
    "label": "Swing Shop",
    "value": "Swing Shop"
  },
  {
    "label": "Swing",
    "value": "Swing"
  },
  {
    "label": "T by Alexander Wang",
    "value": "T by Alexander Wang"
  },
  {
    "label": "TAMARIS",
    "value": "TAMARIS"
  },
  {
    "label": "TAN-LUXE",
    "value": "TAN-LUXE"
  },
  {
    "label": "TD by True Decadence",
    "value": "TD by True Decadence"
  },
  {
    "label": "TFNC Curve",
    "value": "TFNC Curve"
  },
  {
    "label": "TFNC Petite",
    "value": "TFNC Petite"
  },
  {
    "label": "TFNC Tall",
    "value": "TFNC Tall"
  },
  {
    "label": "TFNC",
    "value": "TFNC"
  },
  {
    "label": "THE KOOPLES SPORT",
    "value": "THE KOOPLES SPORT"
  },
  {
    "label": "THE NORTH FACE",
    "value": "THE NORTH FACE"
  },
  {
    "label": "THE WHITE BRAND",
    "value": "THE WHITE BRAND"
  },
  {
    "label": "THOMAS HAYO for CRICKIT",
    "value": "THOMAS HAYO for CRICKIT"
  },
  {
    "label": "THOMAS SABO",
    "value": "THOMAS SABO"
  },
  {
    "label": "TIMBERLAND",
    "value": "TIMBERLAND"
  },
  {
    "label": "TOGA Pulla",
    "value": "TOGA Pulla"
  },
  {
    "label": "TOM FORD",
    "value": "TOM FORD"
  },
  {
    "label": "TOM TAILOR DENIM",
    "value": "TOM TAILOR DENIM"
  },
  {
    "label": "TOM TAILOR",
    "value": "TOM TAILOR"
  },
  {
    "label": "TOMMY HILFIGER",
    "value": "TOMMY HILFIGER"
  },
  {
    "label": "TOMS",
    "value": "TOMS"
  },
  {
    "label": "TRIUMPH",
    "value": "TRIUMPH"
  },
  {
    "label": "TRVL DRSS",
    "value": "TRVL DRSS"
  },
  {
    "label": "TW Steel",
    "value": "TW Steel"
  },
  {
    "label": "TWIIN",
    "value": "TWIIN"
  },
  {
    "label": "TWINSET Jeans",
    "value": "TWINSET Jeans"
  },
  {
    "label": "TWINSET",
    "value": "TWINSET"
  },
  {
    "label": "TWINTIP",
    "value": "TWINTIP"
  },
  {
    "label": "Taifun",
    "value": "Taifun"
  },
  {
    "label": "Tamaris Heart & Sole",
    "value": "Tamaris Heart & Sole"
  },
  {
    "label": "Tamaris Shop",
    "value": "Tamaris Shop"
  },
  {
    "label": "Tamaris",
    "value": "Tamaris"
  },
  {
    "label": "Tangent GC",
    "value": "Tangent GC"
  },
  {
    "label": "Tangle Teezer",
    "value": "Tangle Teezer"
  },
  {
    "label": "Tara Jarmon",
    "value": "Tara Jarmon"
  },
  {
    "label": "Tata Italia",
    "value": "Tata Italia"
  },
  {
    "label": "Tatonka",
    "value": "Tatonka"
  },
  {
    "label": "Taupage",
    "value": "Taupage"
  },
  {
    "label": "Ted Baker",
    "value": "Ted Baker"
  },
  {
    "label": "Teddy Smith",
    "value": "Teddy Smith"
  },
  {
    "label": "Ten Points",
    "value": "Ten Points"
  },
  {
    "label": "Teva",
    "value": "Teva"
  },
  {
    "label": "The Boyscouts",
    "value": "The Boyscouts"
  },
  {
    "label": "The Bridge",
    "value": "The Bridge"
  },
  {
    "label": "The Editor",
    "value": "The Editor"
  },
  {
    "label": "The Fifth Label",
    "value": "The Fifth Label"
  },
  {
    "label": "The Jacksons",
    "value": "The Jacksons"
  },
  {
    "label": "The Kooples SPORT",
    "value": "The Kooples SPORT"
  },
  {
    "label": "The Kooples",
    "value": "The Kooples"
  },
  {
    "label": "The North Face",
    "value": "The North Face"
  },
  {
    "label": "The Pack Society",
    "value": "The Pack Society"
  },
  {
    "label": "The Ragged Priest",
    "value": "The Ragged Priest"
  },
  {
    "label": "Theluto",
    "value": "Theluto"
  },
  {
    "label": "Theory",
    "value": "Theory"
  },
  {
    "label": "Thierry Mugler",
    "value": "Thierry Mugler"
  },
  {
    "label": "Think!",
    "value": "Think!"
  },
  {
    "label": "Thomas Sabo",
    "value": "Thomas Sabo"
  },
  {
    "label": "Three Floor",
    "value": "Three Floor"
  },
  {
    "label": "Thule",
    "value": "Thule"
  },
  {
    "label": "Ti Sento Milano",
    "value": "Ti Sento Milano"
  },
  {
    "label": "Tibi",
    "value": "Tibi"
  },
  {
    "label": "Tiffany & Co.",
    "value": "Tiffany & Co."
  },
  {
    "label": "Tiffosi",
    "value": "Tiffosi"
  },
  {
    "label": "Tiger of Sweden Jeans",
    "value": "Tiger of Sweden Jeans"
  },
  {
    "label": "Tiger of Sweden Shop",
    "value": "Tiger of Sweden Shop"
  },
  {
    "label": "Tiger of Sweden",
    "value": "Tiger of Sweden"
  },
  {
    "label": "Tigha",
    "value": "Tigha"
  },
  {
    "label": "Timberland",
    "value": "Timberland"
  },
  {
    "label": "Timeless Truth Mask",
    "value": "Timeless Truth Mask"
  },
  {
    "label": "Timex",
    "value": "Timex"
  },
  {
    "label": "Tissot",
    "value": "Tissot"
  },
  {
    "label": "Titan",
    "value": "Titan"
  },
  {
    "label": "Tkees",
    "value": "Tkees"
  },
  {
    "label": "Toasties",
    "value": "Toasties"
  },
  {
    "label": "Tom Joule",
    "value": "Tom Joule"
  },
  {
    "label": "Tom Tailor",
    "value": "Tom Tailor"
  },
  {
    "label": "TomShot",
    "value": "TomShot"
  },
  {
    "label": "Tommy Jeans",
    "value": "Tommy Jeans"
  },
  {
    "label": "Tomorrow",
    "value": "Tomorrow"
  },
  {
    "label": "Toni Sailer",
    "value": "Toni Sailer"
  },
  {
    "label": "Tonymoly",
    "value": "Tonymoly"
  },
  {
    "label": "Top Secret",
    "value": "Top Secret"
  },
  {
    "label": "Topshop",
    "value": "Topshop"
  },
  {
    "label": "Toral Shop",
    "value": "Toral Shop"
  },
  {
    "label": "Toral",
    "value": "Toral"
  },
  {
    "label": "Tory Burch",
    "value": "Tory Burch"
  },
  {
    "label": "Tosca Blu",
    "value": "Tosca Blu"
  },
  {
    "label": "Travelite",
    "value": "Travelite"
  },
  {
    "label": "Tresophie",
    "value": "Tresophie"
  },
  {
    "label": "Triangle",
    "value": "Triangle"
  },
  {
    "label": "Tricot pop",
    "value": "Tricot pop"
  },
  {
    "label": "Triple2",
    "value": "Triple2"
  },
  {
    "label": "Triumph Shop",
    "value": "Triumph Shop"
  },
  {
    "label": "Triumph Triaction",
    "value": "Triumph Triaction"
  },
  {
    "label": "Triumph",
    "value": "Triumph"
  },
  {
    "label": "True Decadence Tall",
    "value": "True Decadence Tall"
  },
  {
    "label": "True Decadence",
    "value": "True Decadence"
  },
  {
    "label": "True Religion",
    "value": "True Religion"
  },
  {
    "label": "True Violet",
    "value": "True Violet"
  },
  {
    "label": "Trussardi Jeans",
    "value": "Trussardi Jeans"
  },
  {
    "label": "Trussardi",
    "value": "Trussardi"
  },
  {
    "label": "Tumi",
    "value": "Tumi"
  },
  {
    "label": "Turnover",
    "value": "Turnover"
  },
  {
    "label": "Tweezerman",
    "value": "Tweezerman"
  },
  {
    "label": "Twintip Plus",
    "value": "Twintip Plus"
  },
  {
    "label": "Twintip Shop",
    "value": "Twintip Shop"
  },
  {
    "label": "Twist & Tango",
    "value": "Twist & Tango"
  },
  {
    "label": "U.S. Polo Assn.",
    "value": "U.S. Polo Assn."
  },
  {
    "label": "UGG",
    "value": "UGG"
  },
  {
    "label": "UMA PARKER",
    "value": "UMA PARKER"
  },
  {
    "label": "UNDER ARMOUR",
    "value": "UNDER ARMOUR"
  },
  {
    "label": "UNMADE Copenhagen",
    "value": "UNMADE Copenhagen"
  },
  {
    "label": "UYN",
    "value": "UYN"
  },
  {
    "label": "Ucon Acrobatics",
    "value": "Ucon Acrobatics"
  },
  {
    "label": "Uhlsport",
    "value": "Uhlsport"
  },
  {
    "label": "Ultimate Direction",
    "value": "Ultimate Direction"
  },
  {
    "label": "Ultimo",
    "value": "Ultimo"
  },
  {
    "label": "Umbra",
    "value": "Umbra"
  },
  {
    "label": "Umbro Projects",
    "value": "Umbro Projects"
  },
  {
    "label": "Umbro Shop",
    "value": "Umbro Shop"
  },
  {
    "label": "Un Jean",
    "value": "Un Jean"
  },
  {
    "label": "Under Armour",
    "value": "Under Armour"
  },
  {
    "label": "Underprotection",
    "value": "Underprotection"
  },
  {
    "label": "Undress Code",
    "value": "Undress Code"
  },
  {
    "label": "Unique",
    "value": "Unique"
  },
  {
    "label": "Unisa",
    "value": "Unisa"
  },
  {
    "label": "Uno Piu Uno",
    "value": "Uno Piu Uno"
  },
  {
    "label": "Urban Classics Curvy",
    "value": "Urban Classics Curvy"
  },
  {
    "label": "Urban Classics Shop",
    "value": "Urban Classics Shop"
  },
  {
    "label": "Urban Classics",
    "value": "Urban Classics"
  },
  {
    "label": "Urbanista",
    "value": "Urbanista"
  },
  {
    "label": "Usha",
    "value": "Usha"
  },
  {
    "label": "Uvex",
    "value": "Uvex"
  },
  {
    "label": "Uzurii",
    "value": "Uzurii"
  },
  {
    "label": "VAGABOND SHOEMAKERS",
    "value": "VAGABOND SHOEMAKERS"
  },
  {
    "label": "VANS",
    "value": "VANS"
  },
  {
    "label": "VANZETTI",
    "value": "VANZETTI"
  },
  {
    "label": "VAUDE",
    "value": "VAUDE"
  },
  {
    "label": "VENICE BEACH",
    "value": "VENICE BEACH"
  },
  {
    "label": "VERBENAS",
    "value": "VERBENAS"
  },
  {
    "label": "VERO MODA",
    "value": "VERO MODA"
  },
  {
    "label": "VERSACE",
    "value": "VERSACE"
  },
  {
    "label": "VILA",
    "value": "VILA"
  },
  {
    "label": "VIVANCE",
    "value": "VIVANCE"
  },
  {
    "label": "VIVE MARIA",
    "value": "VIVE MARIA"
  },
  {
    "label": "VM Vera Mont",
    "value": "VM Vera Mont"
  },
  {
    "label": "VOGUE Eyewear",
    "value": "VOGUE Eyewear"
  },
  {
    "label": "VSP",
    "value": "VSP"
  },
  {
    "label": "Vagabond",
    "value": "Vagabond"
  },
  {
    "label": "Valentino Handbags",
    "value": "Valentino Handbags"
  },
  {
    "label": "Valentino by Mario Valentino",
    "value": "Valentino by Mario Valentino"
  },
  {
    "label": "Valentino",
    "value": "Valentino"
  },
  {
    "label": "Vanessa Bruno",
    "value": "Vanessa Bruno"
  },
  {
    "label": "Vanilia",
    "value": "Vanilia"
  },
  {
    "label": "Vanity Fair Lingerie",
    "value": "Vanity Fair Lingerie"
  },
  {
    "label": "Vanrycke",
    "value": "Vanrycke"
  },
  {
    "label": "Vans",
    "value": "Vans"
  },
  {
    "label": "Vanzetti",
    "value": "Vanzetti"
  },
  {
    "label": "Varley",
    "value": "Varley"
  },
  {
    "label": "Vaude",
    "value": "Vaude"
  },
  {
    "label": "Veja",
    "value": "Veja"
  },
  {
    "label": "Venice Beach",
    "value": "Venice Beach"
  },
  {
    "label": "Ventcouvert",
    "value": "Ventcouvert"
  },
  {
    "label": "Vera Mont",
    "value": "Vera Mont"
  },
  {
    "label": "Vero Moda",
    "value": "Vero Moda"
  },
  {
    "label": "Versace Collection",
    "value": "Versace Collection"
  },
  {
    "label": "Versace Jeans",
    "value": "Versace Jeans"
  },
  {
    "label": "Versace Shop",
    "value": "Versace Shop"
  },
  {
    "label": "Versace Watches",
    "value": "Versace Watches"
  },
  {
    "label": "Versace",
    "value": "Versace"
  },
  {
    "label": "Versus Versace",
    "value": "Versus Versace"
  },
  {
    "label": "Vibe Harsløf",
    "value": "Vibe Harsløf"
  },
  {
    "label": "Vibram Fivefingers",
    "value": "Vibram Fivefingers"
  },
  {
    "label": "Vic",
    "value": "Vic"
  },
  {
    "label": "Victoria Shoes",
    "value": "Victoria Shoes"
  },
  {
    "label": "Victoria Victoria Beckham",
    "value": "Victoria Victoria Beckham"
  },
  {
    "label": "Victorinox",
    "value": "Victorinox"
  },
  {
    "label": "Vidorreta",
    "value": "Vidorreta"
  },
  {
    "label": "Viktor&Rolf",
    "value": "Viktor&Rolf"
  },
  {
    "label": "Vila",
    "value": "Vila"
  },
  {
    "label": "Vince Camuto Petite",
    "value": "Vince Camuto Petite"
  },
  {
    "label": "Vince Camuto Plus",
    "value": "Vince Camuto Plus"
  },
  {
    "label": "Vince Camuto",
    "value": "Vince Camuto"
  },
  {
    "label": "Violeta by Mango",
    "value": "Violeta by Mango"
  },
  {
    "label": "Vitti Love",
    "value": "Vitti Love"
  },
  {
    "label": "Vive Maria",
    "value": "Vive Maria"
  },
  {
    "label": "Vivienne Westwood",
    "value": "Vivienne Westwood"
  },
  {
    "label": "Voile Blanche",
    "value": "Voile Blanche"
  },
  {
    "label": "Volcom",
    "value": "Volcom"
  },
  {
    "label": "Von Lotzbeck",
    "value": "Von Lotzbeck"
  },
  {
    "label": "Vossen",
    "value": "Vossen"
  },
  {
    "label": "WAL G.",
    "value": "WAL G."
  },
  {
    "label": "WAY OUT LONDON",
    "value": "WAY OUT LONDON"
  },
  {
    "label": "WE Fashion",
    "value": "WE Fashion"
  },
  {
    "label": "WEEKEND MaxMara",
    "value": "WEEKEND MaxMara"
  },
  {
    "label": "WHITE STUFF",
    "value": "WHITE STUFF"
  },
  {
    "label": "WHY7",
    "value": "WHY7"
  },
  {
    "label": "WOOD WOOD",
    "value": "WOOD WOOD"
  },
  {
    "label": "WRANGLER",
    "value": "WRANGLER"
  },
  {
    "label": "WYLDR",
    "value": "WYLDR"
  },
  {
    "label": "Wacoal",
    "value": "Wacoal"
  },
  {
    "label": "Wallis Petite",
    "value": "Wallis Petite"
  },
  {
    "label": "Wallis Shop",
    "value": "Wallis Shop"
  },
  {
    "label": "Wallis",
    "value": "Wallis"
  },
  {
    "label": "Wandler",
    "value": "Wandler"
  },
  {
    "label": "Warehouse",
    "value": "Warehouse"
  },
  {
    "label": "WeSC",
    "value": "WeSC"
  },
  {
    "label": "Wearcolour",
    "value": "Wearcolour"
  },
  {
    "label": "Weekday",
    "value": "Weekday"
  },
  {
    "label": "Weekend",
    "value": "Weekend"
  },
  {
    "label": "Welter Shelter",
    "value": "Welter Shelter"
  },
  {
    "label": "Wemoto",
    "value": "Wemoto"
  },
  {
    "label": "Whistles",
    "value": "Whistles"
  },
  {
    "label": "White Mountaineering",
    "value": "White Mountaineering"
  },
  {
    "label": "White Stuff",
    "value": "White Stuff"
  },
  {
    "label": "Whyred",
    "value": "Whyred"
  },
  {
    "label": "Wiesnkönig",
    "value": "Wiesnkönig"
  },
  {
    "label": "Wild Feet",
    "value": "Wild Feet"
  },
  {
    "label": "Windmillkey",
    "value": "Windmillkey"
  },
  {
    "label": "Windrose",
    "value": "Windrose"
  },
  {
    "label": "Woden",
    "value": "Woden"
  },
  {
    "label": "Wolf & Whistle",
    "value": "Wolf & Whistle"
  },
  {
    "label": "Wolford",
    "value": "Wolford"
  },
  {
    "label": "Wolvis",
    "value": "Wolvis"
  },
  {
    "label": "Woman by Earn",
    "value": "Woman by Earn"
  },
  {
    "label": "Women Secret",
    "value": "Women Secret"
  },
  {
    "label": "Won Hundred",
    "value": "Won Hundred"
  },
  {
    "label": "Wonderbra",
    "value": "Wonderbra"
  },
  {
    "label": "Wood Wood",
    "value": "Wood Wood"
  },
  {
    "label": "Wouf",
    "value": "Wouf"
  },
  {
    "label": "Wouters & Hendrix",
    "value": "Wouters & Hendrix"
  },
  {
    "label": "Wouters en Hendrix",
    "value": "Wouters en Hendrix"
  },
  {
    "label": "Wrangler by Peter Max",
    "value": "Wrangler by Peter Max"
  },
  {
    "label": "Wrangler",
    "value": "Wrangler"
  },
  {
    "label": "Wåven",
    "value": "Wåven"
  },
  {
    "label": "X Bionic",
    "value": "X Bionic"
  },
  {
    "label": "X Socks",
    "value": "X Socks"
  },
  {
    "label": "XTI",
    "value": "XTI"
  },
  {
    "label": "Y-3",
    "value": "Y-3"
  },
  {
    "label": "Y.A.S",
    "value": "Y.A.S"
  },
  {
    "label": "YAS Tall",
    "value": "YAS Tall"
  },
  {
    "label": "YAS",
    "value": "YAS"
  },
  {
    "label": "YOGA CURVES",
    "value": "YOGA CURVES"
  },
  {
    "label": "YOLKE",
    "value": "YOLKE"
  },
  {
    "label": "YOURTURN Shop",
    "value": "YOURTURN Shop"
  },
  {
    "label": "YOURTURN",
    "value": "YOURTURN"
  },
  {
    "label": "YUJ",
    "value": "YUJ"
  },
  {
    "label": "YUMA",
    "value": "YUMA"
  },
  {
    "label": "Yargici",
    "value": "Yargici"
  },
  {
    "label": "Yeezy",
    "value": "Yeezy"
  },
  {
    "label": "Yes I Do",
    "value": "Yes I Do"
  },
  {
    "label": "Yeti",
    "value": "Yeti"
  },
  {
    "label": "Yoek",
    "value": "Yoek"
  },
  {
    "label": "Yoga Jeans",
    "value": "Yoga Jeans"
  },
  {
    "label": "Yogasearcher",
    "value": "Yogasearcher"
  },
  {
    "label": "Yogitoes",
    "value": "Yogitoes"
  },
  {
    "label": "Yosi Samra",
    "value": "Yosi Samra"
  },
  {
    "label": "Young Couture by Barbara Schwarzer",
    "value": "Young Couture by Barbara Schwarzer"
  },
  {
    "label": "Yumi",
    "value": "Yumi"
  },
  {
    "label": "Yves Delorme",
    "value": "Yves Delorme"
  },
  {
    "label": "Yves Saint Laurent",
    "value": "Yves Saint Laurent"
  },
  {
    "label": "ZAC Zac Posen",
    "value": "ZAC Zac Posen"
  },
  {
    "label": "ZIENER",
    "value": "ZIENER"
  },
  {
    "label": "ZOE KARSSEN",
    "value": "ZOE KARSSEN"
  },
  {
    "label": "Zadig & Voltaire",
    "value": "Zadig & Voltaire"
  },
  {
    "label": "Zalando",
    "value": "Zalando"
  },
  {
    "label": "Zenggi",
    "value": "Zenggi"
  },
  {
    "label": "Zenology",
    "value": "Zenology"
  },
  {
    "label": "Zespa",
    "value": "Zespa"
  },
  {
    "label": "Zhenzi",
    "value": "Zhenzi"
  },
  {
    "label": "Ziener",
    "value": "Ziener"
  },
  {
    "label": "Zign Shop",
    "value": "Zign Shop"
  },
  {
    "label": "Zign",
    "value": "Zign"
  },
  {
    "label": "Zimtstern",
    "value": "Zimtstern"
  },
  {
    "label": "Zizzi",
    "value": "Zizzi"
  },
  {
    "label": "Zoe Karssen",
    "value": "Zoe Karssen"
  },
  {
    "label": "Zoggs",
    "value": "Zoggs"
  },
  {
    "label": "Zwilling J.A. Henckels",
    "value": "Zwilling J.A. Henckels"
  },
  {
    "label": "Zwillingsherz",
    "value": "Zwillingsherz"
  },
  {
    "label": "adidas Golf",
    "value": "adidas Golf"
  },
  {
    "label": "adidas Originals",
    "value": "adidas Originals"
  },
  {
    "label": "adidas Performance",
    "value": "adidas Performance"
  },
  {
    "label": "adidas Shop",
    "value": "adidas Shop"
  },
  {
    "label": "adidas by Stella McCartney",
    "value": "adidas by Stella McCartney"
  },
  {
    "label": "adidas",
    "value": "adidas"
  },
  {
    "label": "aim'n",
    "value": "aim'n"
  },
  {
    "label": "alife & kickin",
    "value": "alife & kickin"
  },
  {
    "label": "anello",
    "value": "anello"
  },
  {
    "label": "another project",
    "value": "another project"
  },
  {
    "label": "ara Shop",
    "value": "ara Shop"
  },
  {
    "label": "ara",
    "value": "ara"
  },
  {
    "label": "armedangels",
    "value": "armedangels"
  },
  {
    "label": "b.belt Handmade in Germany",
    "value": "b.belt Handmade in Germany"
  },
  {
    "label": "b.belt",
    "value": "b.belt"
  },
  {
    "label": "b.young",
    "value": "b.young"
  },
  {
    "label": "ba&sh",
    "value": "ba&sh"
  },
  {
    "label": "bellybutton",
    "value": "bellybutton"
  },
  {
    "label": "bugatti",
    "value": "bugatti"
  },
  {
    "label": "camano",
    "value": "camano"
  },
  {
    "label": "camel active",
    "value": "camel active"
  },
  {
    "label": "chillouts",
    "value": "chillouts"
  },
  {
    "label": "cloverpost",
    "value": "cloverpost"
  },
  {
    "label": "comma Shop",
    "value": "comma Shop"
  },
  {
    "label": "comma casual identity",
    "value": "comma casual identity"
  },
  {
    "label": "comma",
    "value": "comma"
  },
  {
    "label": "de Bijenkorf Home",
    "value": "de Bijenkorf Home"
  },
  {
    "label": "dinh van",
    "value": "dinh van"
  },
  {
    "label": "diptyque",
    "value": "diptyque"
  },
  {
    "label": "ecco",
    "value": "ecco"
  },
  {
    "label": "edc by Esprit",
    "value": "edc by Esprit"
  },
  {
    "label": "egos copenhagen",
    "value": "egos copenhagen"
  },
  {
    "label": "ellesse",
    "value": "ellesse"
  },
  {
    "label": "else",
    "value": "else"
  },
  {
    "label": "elvine",
    "value": "elvine"
  },
  {
    "label": "espadrij l´originale",
    "value": "espadrij l´originale"
  },
  {
    "label": "even&odd",
    "value": "even&odd"
  },
  {
    "label": "extreme cashmere",
    "value": "extreme cashmere"
  },
  {
    "label": "flip*flop",
    "value": "flip*flop"
  },
  {
    "label": "gap Shop",
    "value": "gap Shop"
  },
  {
    "label": "gwynedds",
    "value": "gwynedds"
  },
  {
    "label": "heine",
    "value": "heine"
  },
  {
    "label": "i.am+",
    "value": "i.am+"
  },
  {
    "label": "iBlues",
    "value": "iBlues"
  },
  {
    "label": "iPHORIA",
    "value": "iPHORIA"
  },
  {
    "label": "iittala",
    "value": "iittala"
  },
  {
    "label": "indi & cold",
    "value": "indi & cold"
  },
  {
    "label": "kate spade new york connected",
    "value": "kate spade new york connected"
  },
  {
    "label": "kate spade new york",
    "value": "kate spade new york"
  },
  {
    "label": "khujo",
    "value": "khujo"
  },
  {
    "label": "le coq sportif",
    "value": "le coq sportif"
  },
  {
    "label": "lilimill",
    "value": "lilimill"
  },
  {
    "label": "maje",
    "value": "maje"
  },
  {
    "label": "mamalicious",
    "value": "mamalicious"
  },
  {
    "label": "marlies | dekkers",
    "value": "marlies | dekkers"
  },
  {
    "label": "mascara",
    "value": "mascara"
  },
  {
    "label": "mazine",
    "value": "mazine"
  },
  {
    "label": "mbym",
    "value": "mbym"
  },
  {
    "label": "minimum",
    "value": "minimum"
  },
  {
    "label": "mint&berry Shop",
    "value": "mint&berry Shop"
  },
  {
    "label": "mint&berry mom",
    "value": "mint&berry mom"
  },
  {
    "label": "mint&berry",
    "value": "mint&berry"
  },
  {
    "label": "miss goodlife",
    "value": "miss goodlife"
  },
  {
    "label": "modström",
    "value": "modström"
  },
  {
    "label": "monari",
    "value": "monari"
  },
  {
    "label": "mp Denmark",
    "value": "mp Denmark"
  },
  {
    "label": "mtng",
    "value": "mtng"
  },
  {
    "label": "myMo",
    "value": "myMo"
  },
  {
    "label": "naketano",
    "value": "naketano"
  },
  {
    "label": "new balance",
    "value": "new balance"
  },
  {
    "label": "no man's land",
    "value": "no man's land"
  },
  {
    "label": "ohma!",
    "value": "ohma!"
  },
  {
    "label": "ohw?",
    "value": "ohw?"
  },
  {
    "label": "one more story",
    "value": "one more story"
  },
  {
    "label": "pinqponq",
    "value": "pinqponq"
  },
  {
    "label": "pure cashmere",
    "value": "pure cashmere"
  },
  {
    "label": "rag & bone",
    "value": "rag & bone"
  },
  {
    "label": "re.draft",
    "value": "re.draft"
  },
  {
    "label": "recolution",
    "value": "recolution"
  },
  {
    "label": "rosemunde",
    "value": "rosemunde"
  },
  {
    "label": "s.Oliver",
    "value": "s.Oliver"
  },
  {
    "label": "sandro",
    "value": "sandro"
  },
  {
    "label": "saucony",
    "value": "saucony"
  },
  {
    "label": "seeyou",
    "value": "seeyou"
  },
  {
    "label": "sergio tacchini",
    "value": "sergio tacchini"
  },
  {
    "label": "sheeGOTit",
    "value": "sheeGOTit"
  },
  {
    "label": "sheego Basic",
    "value": "sheego Basic"
  },
  {
    "label": "sheego casual",
    "value": "sheego casual"
  },
  {
    "label": "sheego class",
    "value": "sheego class"
  },
  {
    "label": "sheego style",
    "value": "sheego style"
  },
  {
    "label": "sheego trend",
    "value": "sheego trend"
  },
  {
    "label": "someday.",
    "value": "someday."
  },
  {
    "label": "super.natural",
    "value": "super.natural"
  },
  {
    "label": "sweet deluxe",
    "value": "sweet deluxe"
  },
  {
    "label": "sweewë",
    "value": "sweewë"
  },
  {
    "label": "talkabout",
    "value": "talkabout"
  },
  {
    "label": "tigha",
    "value": "tigha"
  },
  {
    "label": "triaction by Triumph",
    "value": "triaction by Triumph"
  },
  {
    "label": "trueprodigy",
    "value": "trueprodigy"
  },
  {
    "label": "twenty tees",
    "value": "twenty tees"
  },
  {
    "label": "van Laack",
    "value": "van Laack"
  },
  {
    "label": "watercult",
    "value": "watercult"
  },
  {
    "label": "xyxyx",
    "value": "xyxyx"
  },
  {
    "label": "Élysèss",
    "value": "Élysèss"
  },
  {
    "label": "ZARA",
    "value": "ZARA"
  },
  {
    "label": "Massimo Dutti",
    "value": "Massimo Dutti"
  },
  {
    "label": "Pull&Bear",
    "value": "Pull&Bear"
  },
  {
    "label": "Bershka",
    "value": "Bershka"
  },
  {
    "label": "COS",
    "value": "COS"
  },
  {
    "label": "Cheap Monday",
    "value": "Cheap Monday"
  }

];

export const newBrands = [
  {
    "label": "WE Fashion",
    "key": "WE Fashion",
  },
  {
    "label": "America Today",
    "key": "America Today",
  },
  {
    "label": "Vila",
    "key": "Vila",
  },
  {
    "label": "Zara",
    "key": "Zara",
  },
  {
    "label": "H&M",
    "key": "H&M",
  },
  {
    "label": "Costess",
    "key": "Costess",
  },
  {
    "label": "NA-KD",
    "key": "NA-KD",
  },
  {
    "label": "Yaya",
    "key": "Yaya",
  },
  {
    "label": "Esprit",
    "key": "Esprit",
  },
  {
    "label": "Steps",
    "key": "Steps",
  },
  {
    "label": "Summum",
    "key": "Summum",
  },
  {
    "label": "Benetton",
    "key": "Benetton",
  },
  {
    "label": "Colourful Rebel",
    "key": "Colourful Rebel",
  },
  {
    "label": "Topshop",
    "key": "Topshop",
  },
  {
    "label": "Alix The Label",
    "key": "Alix The Label",
  },
  {
    "label": "By Bar",
    "key": "By Bar",
  },
  {
    "label": "Cavallaro",
    "key": "Cavallaro",
  },
  {
    "label": "Drykorn",
    "key": "Drykorn",
  },
  {
    "label": "Expresso",
    "key": "Expresso",
  },
  {
    "label": "Claudia Sträter",
    "key": "Claudia Sträter",
  },
  {
    "label": "La Dress",
    "key": "La Dress",
  },
  {
    "label": "Desigual",
    "key": "Desigual",
  },
  {
    "label": "Geisha",
    "key": "Geisha",
  },
  {
    "label": "Levi's",
    "key": "Levi's",
  },
  {
    "label": "Fabienne Chapot",
    "key": "Fabienne Chapot",
  },
  {
    "label": "Dante6",
    "key": "Dante6",
  },
  {
    "label": "G-Star",
    "key": "G-Star",
  },
  {
    "label": "Adidas Originals",
    "key": "Adidas Originals",
  },
  {
    "label": "Obey",
    "key": "Obey",
  },
  {
    "label": "Cambio",
    "key": "Cambio",
  },
  {
    "label": "Penn & Ink",
    "key": "Penn & Ink",
  },
  {
    "label": "Sissy Boy",
    "key": "Sissy Boy",
  },
  {
    "label": "French Connection",
    "key": "French Connection",
  },
  {
    "label": "Maison Scotch",
    "key": "Maison Scotch",
  },
  {
    "label": "Goosecraft",
    "key": "Goosecraft",
  },
  {
    "label": "Minimum",
    "key": "Minimum",
  },
  {
    "label": "Modström",
    "key": "Modström",
  },
  {
    "label": "Samsøe & Samsøe",
    "key": "Samsøe & Samsøe",
  },
  {
    "label": "Vanilia",
    "key": "Vanilia",
  },
  {
    "label": "Repeat",
    "key": "Repeat",
  },
  {
    "label": "Superdry",
    "key": "Superdry",
  },
  {
    "label": "Saint Tropez",
    "key": "Saint Tropez",
  },
  {
    "label": "10 Days",
    "key": "10 Days",
  },
  {
    "label": "NIKKIE",
    "key": "NIKKIE",
  },
  {
    "label": "L.K. Bennett",
    "key": "L.K. Bennett",
  },
  {
    "label": "Claudie Pierlot",
    "key": "Claudie Pierlot",
  },
  {
    "label": "Hugo Boss",
    "key": "Hugo Boss",
  },
  {
    "label": "Tommy Hilfiger",
    "key": "Tommy Hilfiger",
  },
  {
    "label": "Michael Kors",
    "key": "Michael Kors",
  },
  {
    "label": "See By Chloé",
    "key": "See By Chloé",
  },
  {
    "label": "Ganni",
    "key": "Ganni",
  },
  {
    "label": "Essentiel",
    "key": "Essentiel",
  },
  {
    "label": "Acne",
    "key": "Acne",
  },
  {
    "label": "Anecdote",
    "key": "Anecdote",
  },
  {
    "label": "Max Mara",
    "key": "Max Mara",
  },
  {
    "label": "Marc Cain",
    "key": "Marc Cain",
  },
  {
    "label": "Sandro",
    "key": "Sandro",
  },
  {
    "label": "Maje",
    "key": "Maje",
  },
  {
    "label": "Ted Baker",
    "key": "Ted Baker",
  },
  {
    "label": "Zadig & Voltaire",
    "key": "Zadig & Voltaire",
  },
  {
    "label": "Iro",
    "key": "Iro",
  },
  {
    "label": "Jigsaw",
    "key": "Jigsaw",
  },
  {
    "label": "7 for all Mankind",
    "key": "7 for all Mankind",
  },
  {
    "label": "Karen Millen",
    "key": "Karen Millen",
  },
  {
    "label": "Aaiko",
    "key": "Aaiko",
  },
  {
    "label": "Filippa K",
    "key": "Filippa K",
  },
  {
    "label": "Ba&sh",
    "key": "Ba&sh",
  },
  {
    "label": "Balmain",
    "key": "Balmain",
  },
  {
    "label": "Chanel",
    "key": "Chanel",
  },
  {
    "label": "Isabel Marant",
    "key": "Isabel Marant",
  },
  {
    "label": "Stella McCartney",
    "key": "Stella McCartney",
  },
];
